import { LocalizationService } from './../../services/localization/localization.service';
import { SelectedSuggestionPillDataModel } from './../../models/search-config-data-model';
import { ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY, ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY } from './../../config/dynamic-forms/affiliations-contants';
import { Injectable, NgZone } from '@angular/core';
import { AccountOfflineService } from '../../services/account/account.offline.service';
import { Endpoints } from '../../../config/endpoints.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DiskService, OFFLINE_DATA_COUNT_ENTITY_NAME, OFFLINE_DB_LINKED_ENTITY_NAME } from '../../services/disk/disk.service';
import { Account, AccountGlobalSearchDTO,  CustomerSpecaility, customerAddress } from '../../classes/account/account.class';
import { AuthenticationService } from '../../services/authentication.service';
import { DB_SYNC_STATE_KEYS, DB_KEY_PREFIXES, DB_ALLDOCS_QUERY_OPTIONS, PREFIX_SEARCH_ENDKEY_UNICODE } from '../../config/pouch-db.config';
import { DeltaService, EntityNames, EntitySyncInfo } from '../delta/delta.service';
import { timeout } from 'rxjs/operators';
import { DynamicForm, FormType, ControlDataType, Control } from '@omni/classes/dynamic-form/dynamic-form.class';
import { DynamicFormsService } from '@omni/services/dynamic-forms/dynamic-forms-service';
import { DynamicFormType } from '@omni/models/dynamic-form-component.model';
import { DefaultAccountDisplayForm, RequiredAccountAttributes, AccountSearchConfigExcludedAttributes, AccountsPositionFilter, FETCH_ACCOUNT_DEFAULT_LINK_ENTITES, ACCOUNT_EVENT_FETCH_QUERIES, ACCOUNT_LIST_PERIOD_TAG, CustomerPositionFilter } from '@omni/config/dynamic-forms/default-account-display';
import { SearchConfigService } from '@omni/services/search/search-config.service';
import { fetchQueries } from '@omni/config/dynamics-fetchQueries';
import { searchIndexDataModel } from '@omni/models/search-config-data-model';
import { DynamicsClientService } from '../dynamics-client/dynamics-client.service';
import * as XML2JS from 'xml2js';
import { TranslateService } from '@ngx-translate/core';
import { SecondaryInfoEntityName } from '@omni/classes/sec-info-config/sec-info.class';
import { SecInfoConfigDataService } from '../sec-info-config/sec-info-config-data-service';
import { getSearchSuggestionsData } from '../../utility/global-search.utility';
import {MyAssistantService, NOTIFICATION} from "@omni/services/my-assistant/my-assistant.service";
import {IndNotificationDataModel} from "@omni/models/indNotificationDataModel";
import { EventActivity } from '@omni/classes/events-tool/event.class';
import { FeatureActionsMap } from '@omni/classes/authentication/user.class';
import { DeviceService } from '@omni/services/device/device.service';
import { EntityTag, TagEntityType, TagStateCode, UserTag, UserTagService } from '@omni/services/user-tag/user-tag.service';
import { CONTACT_FETCH_QUERIES } from '@omni/config/fetch-xml/contact-fetchXMLs';
import { APPROVAL_STATUS, SelectableLinkedEntity } from '@omni/classes/contact/contact.class';
import { FETCH_ACCOUNTS_LINK_ENTITES_BY_ACCOUNTID } from '../../config//fetch-xml/account/account.fetch-xml.config';
import { SurveyCategory } from '@omni/classes/customer-assessment/assessment-template.class';
import { CustomerAssessService } from '@omni/services/customer-assess/customer-assess.service';
import { DateTimeFormatsService } from '@omni/services/date-time-formats/date-time-formats.service';
import { ContactOfflineService, ContactTag, CustomerTagStateCode, UserTagForContact } from '@omni/services/contact/contact.service';
import { ContactDataService } from '../contact/contact.data.service';
import { PresentationDataService } from '../presentation/presentation.data.service';
import { ResourceDataService } from '../resource/resource.data.service';
import { batched, DynamicsConstant } from '@omni/utility/util';
import { ACCOUNT_TIMELINE_FETCH_QUERIES } from '@omni/config/timeline-fetchQueries';
import { CaseActivity } from '@omni/classes/case-intake/case-activity.class';
import { Activity, ActivityType } from '@omni/classes/activity/activity.class';
import { SurgeryOrderActivity } from '@omni/classes/activity/surgery-order.activity.class';
import { ProcedureTrackerActivity } from '@omni/classes/activity/procedure-tracker.activity.class';
import { OrderActivity } from '@omni/classes/activity/order.activity.class';
import { OrderCaptureActivity } from '@omni/classes/activity/order-capture.activity.class';
import { AppointmentActivity } from '@omni/classes/activity/appointment.activity.class';
import { Presentation } from '@omni/classes/presentation/presentation.class';
import { Resource } from '@omni/classes/resource/resource.class';
import { PhoneActivity } from '@omni/classes/activity/phone.activity.class';
import { FollowUpActivity } from '@omni/classes/activity/follow-up-action.activity.class';
import { Brand } from '@omni/classes/brand/brand.class';
import { AccompainedUser } from '@omni/classes/activity/accompained-user.class';
import { EmailActivity } from '@omni/classes/activity/email.activity.class';
import { SyncProfilerService } from '../../services/logging/sync-profiler.service';
import { entries, groupBy, intersectionBy, isEmpty, omitBy, orderBy, sortBy, uniqBy, xorBy } from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class AccountDataService {

    // list of all linked entites from form
    public accountLinkEntities: Array<string> = [];
    private _advancedSearchConfigServiceWorker;
    private accountsNotificationModel: IndNotificationDataModel;

    // Workers for batch and async processing
    private _dataPartitionWorker;
    private _isDataPartitionWorkerBusy = false;
    private _queuedPartitionPayload = null;
    private _accountsSaved: Promise<void> = Promise.resolve();
    private _onAccountsSaved: () => void = () => {};
    private _accountsSyncLock: Promise<unknown> = Promise.resolve();

    private _linkedEntityWorker;
    private _isLinkedEntityWorkerBusy = false;
    private _linkedEntityWorkerQueue: Array<{entityName: string, data: any[], dbKeyPrefix?: string}> = [];


    constructor(
        private disk: DiskService,
        private http: HttpClient,
        private accountOfflineService: AccountOfflineService,
        private authService: AuthenticationService,
        private deltaService: DeltaService,
        private dynamicFormsService: DynamicFormsService,
        private searchConfigService: SearchConfigService,
        private dynamics: DynamicsClientService,
        private ngZone: NgZone,
        private translate: TranslateService,
        private secondaryInfoService: SecInfoConfigDataService,
        private localizationService: LocalizationService,
        private myAssistantService: MyAssistantService,
        private readonly device: DeviceService,
        private readonly userTagService: UserTagService,
        private contactOfflineService: ContactOfflineService,
        private customerAssessService: CustomerAssessService,
        private dateService : DateTimeFormatsService,
        private readonly contactService: ContactDataService,
        private readonly presentationService: PresentationDataService,
        private readonly resourceService: ResourceDataService,
        private readonly syncProfilerService: SyncProfilerService,
    ) {
        this._initAdvancedSearchServiceWorker();
        this._initDataPartitionWorker();
        this._initLinkedEntityWorker();
    }


    /**
     *    We need to either do a full sync where we download everything or a partial delta sync.
     *
     * @returns {boolean}
     * @memberof AccountDataService
     */
    public async syncAccounts(forceFullSync: boolean = false, loadFromDbOnly = false, profilerParentSpanId?: string): Promise<void> {
        let syncState = await this.disk.getSyncState(DB_SYNC_STATE_KEYS.SYNC_ACCOUNT);
        const isInitialSync = !syncState || !syncState.lastUpdatedTime;
        let doFullSync = forceFullSync || isInitialSync;
        const newLastUpdatedTime = new Date().getTime();

        const accountSyncInfo: EntitySyncInfo = {
            entityName: EntityNames.account,
            totalFailed: 0,
            totalSynced: 0,
            errors: [],
            syncStatus: true
        };

        if(loadFromDbOnly){
          await this.syncProfilerService.timeAsync('accounts_display_sync',
            () => this._doAccountsConfiguredDisplaySync(accountSyncInfo, [], doFullSync, loadFromDbOnly, syncState.lastUpdatedTime),
            profilerParentSpanId
          );
        }else{
          // first, getting all account interaction date and type, so it will mapped to account data
        let interactionResponse = await this.syncProfilerService.timeAsync('accounts_interaction_api',
          () => this.syncInteractionDataForAccount(doFullSync, syncState.lastUpdatedTime),
          profilerParentSpanId
        );
        await this.syncProfilerService.timeAsync('accounts_display_sync',
          () => this._doAccountsConfiguredDisplaySync(accountSyncInfo, interactionResponse, doFullSync, loadFromDbOnly, syncState.lastUpdatedTime),
          profilerParentSpanId
        );

        // Add sync info to the service for tracking
        this.deltaService.addEntitySyncInfo(accountSyncInfo);

        // // Done sync. Update sync state.
        if (accountSyncInfo.syncStatus) {
            syncState.lastUpdatedTime = newLastUpdatedTime;
            await this.disk.updateSyncState(syncState);
        }
        this.disk.retrieve(DB_KEY_PREFIXES.ACCOUNT_RECENT_SEARCHES, true).then((doc)=>{
          if(doc && doc.raw){
            this.accountOfflineService.recentSearches = doc.raw
          }
          else {
            this.accountOfflineService.recentSearches = [];
          }
        })
        return;
        }

    }

    /**
     *  This will perform an initial sync and map it standard.
     *     Easy bb
     *
     * @private
     * @memberof AccountDataService
     */
    private async _getAccountsConfiguredDisplayFetchXML(formDef, formType, forceFullSync, lastUpdatedTime, accountId,fetchMultilingualFields:boolean = false) {
        let parentEntityFetchXml = fetchQueries.configuredFormFetchXMLs.fetchConfiguredFormEntity;
        //create attributes
        let parentEntityAttributesStr = '<attribute name="accountid"/>';
        // Default Parent level Attributes

        RequiredAccountAttributes.forEach(attr => {
            parentEntityAttributesStr += '<attribute name="' + attr + '"/>'
        });

        if (this.authService.hasFeatureAction(FeatureActionsMap.ACCOUNTS_VEEVA_SELECTION) || this.authService.hasFeatureAction(FeatureActionsMap.ACCOUNTS_VEEVA_GLOBAL_SEARCH)) {
          parentEntityAttributesStr += '<attribute name="omniveev_isusedinonetimemeeting"/>';
          parentEntityAttributesStr += '<attribute name="omniveev_recordstate"/>';
        }

        parentEntityAttributesStr += '<attribute name="indskr_hcovid"/>';

        parentEntityAttributesStr += '<attribute name="entityimage"/>';

        let linkEntityAttributesArray = [];
        const entityNameCurrentForm: string = formDef.entityName;
        formDef.metadata.forEach(tab => {
            tab.controls.forEach(control => {
                if (control.dataType) {
                  let linkedAttrFetchXML = '';
                    if(control.attributeName){
                      if (fetchMultilingualFields && control.lookupEntityPrimaryId && control.lookupEntityPrimaryId == "omnione_onekeycodeslabelsid") {
                        this.localizationService.multiLingualAttributes.push(control.attributeName);
                        parentEntityAttributesStr += '<attribute name="' + control.attributeName + '"/>';
                        const localeLabelColumn = this.localizationService.getOneKeyTableAttributes();
                        linkedAttrFetchXML = `<link-entity name="omnione_onekeycodeslabels" from="omnione_onekeycodeslabelsid" to="${control.attributeName}" visible="false" link-type="outer"><attribute name="${localeLabelColumn}" alias="${control.attributeName}_loclabel"/></link-entity>`;
                        parentEntityAttributesStr += linkedAttrFetchXML;
                      } else {
                        parentEntityAttributesStr += '<attribute name="' + control.attributeName + '"/>';
                      }
                    }
                    if (control.dataType != ControlDataType.DateTimeType && control.dataType != ControlDataType.CustomerType
                        && control.dataType != ControlDataType.MemoType
                        && control.dataType != ControlDataType.WebResource && control.dataType != ControlDataType.MultiSelectPicklistType
                        && !this.searchConfigService.accountConfiguredSearchIndexConfig.some(conf => conf.categoryRelativePath == control.attributeName)
                        && !AccountSearchConfigExcludedAttributes.some(a=> a == control.attributeName)) {
                        let searchCategory: searchIndexDataModel = {
                            categoryName: this.dynamicFormsService.getSearchConfigDisplayText(control.displayNames, formType, control.isCustom, control.attributeName, entityNameCurrentForm),
                            categoryRelativePath: control.attributeName,
                            controlDataType: control.dataType,
                            values: [],
                            mappingValues: [],
                            parentEntity: 'account',
                            entity: "",
                            linkEntityFetchXML: linkedAttrFetchXML,
                            isBooleanTypeCategory: control.dataType == ControlDataType.BooleanType,
                            numOfLinkEntity: 0,
                            isMultilingualLookup: control.lookupEntityPrimaryId && control.lookupEntityPrimaryId == "omnione_onekeycodeslabelsid",
                        }
                        this.searchConfigService.accountConfiguredSearchIndexConfig.push(searchCategory);
                    }
                }else if (!control.dataType && control.subgrid) {
                    linkEntityAttributesArray.push(control);
                }
            });
        });

        parentEntityFetchXml = parentEntityFetchXml.replace('{parentLevelAttributes}', parentEntityAttributesStr);
        parentEntityFetchXml = parentEntityFetchXml.replace('{parentEntityName}', formDef.entityName);
        parentEntityFetchXml = parentEntityFetchXml.replace('{linkEntityPlaceholder}', '');

        const secondaryFetchXml = this.secondaryInfoService.SecondaryInfoFetchXML(SecondaryInfoEntityName.Account);
        parentEntityFetchXml = parentEntityFetchXml.replace('{secondaryInfoPlaceholder}', secondaryFetchXml || '' );

        let hourDifference;
        if(forceFullSync) {
          let initSyncFilter = '';
          if(!accountId){
            initSyncFilter = `<filter type="and">
                <condition attribute="statecode" operator="eq" value="0" />
              </filter>`;
          }
          parentEntityFetchXml = parentEntityFetchXml.replace('{deltasyncFilterLevel1}',initSyncFilter);
        }else {
            let now = new Date();
            hourDifference = this.dateService.getDifferenceInHours(
                now,
                new Date(lastUpdatedTime)
            )
            //add one to make sure we take care of fractional difference in hours
            hourDifference += 1;
            let lastModifiedFilter = `<filter type="or">
              <condition attribute="modifiedon" operator="last-x-hours" value="`+ hourDifference + `" />
              <condition attribute="modifiedon" operator="last-x-hours" value="`+ hourDifference + `" entityname="indskr_customerpositionfilter"/>
            </filter>`

            if(accountId) {
                lastModifiedFilter = `<filter type="or">
                    <condition attribute="modifiedon" operator="last-x-hours" value="`+ hourDifference + `" />
                </filter>`
            }
            parentEntityFetchXml = parentEntityFetchXml.replace('{deltasyncFilterLevel1}', lastModifiedFilter);
        }

        let positionFilterString = '';
        if(accountId) {
            let accountIdFilter = `<filter type="and"><condition attribute="accountid" operator="eq" value="` + accountId + `" /></filter>`
            parentEntityFetchXml = parentEntityFetchXml.replace('{positionFilterlevel1}', '');
            parentEntityFetchXml = parentEntityFetchXml.replace('{customFilterLevel1}', accountIdFilter);
        } else {
            //create position filter
            positionFilterString = this.getPositionFilterString();
            parentEntityFetchXml = parentEntityFetchXml.replace('{positionFilterlevel1}', positionFilterString);
            parentEntityFetchXml = parentEntityFetchXml.replace('{customFilterLevel1}', '');
        }
        return { parentEntityFetchXml, linkEntityAttributesArray, hourDifference, positionFilterString };
    }
  private getPositionFilterString(withPositionFilter:boolean = false, toAttribute?:string) {
    let positionIds = this.authService.user.positions.map(o => {
      return o.ID;
    });
    let positionIDValues = '';
    positionIds.forEach(p => {
      positionIDValues += '<value>' + p + '</value>';
    });
    let positionFilterString = AccountsPositionFilter.split('{positionIDs}').join(positionIDValues);
    if (withPositionFilter) {
      if (toAttribute) {
        positionFilterString = CustomerPositionFilter.split('{positionIDs}').join(positionIDValues);
        positionFilterString = positionFilterString.replace('{toAttribute}', toAttribute);
      }
    }
    const approvalStatusFilter = this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_VISIBILITY_APPROVAL_BASED)
      ? `<filter type="or">
                <condition attribute="indskr_approvalstatus" operator="eq" value="548910002" />
                <condition attribute="indskr_approvalstatus" operator="null"/>
              </filter>`
      : '';
    const filterOutFromAppSyncFilter = this.authService.hasFeatureAction(FeatureActionsMap.FILTER_OUT_FROM_APP_SYNC)
      ? `<filter type="or">
                  <condition attribute="indskr_filteroutfromappsync" value="1" operator="ne"/>
                  <condition attribute="indskr_overriddefilteroutfromappsync" value="1" operator="eq"/>
              </filter>`
      : "";
    positionFilterString = positionFilterString.replace('{approvalStatusFilter}', approvalStatusFilter);
    positionFilterString = positionFilterString.replace('{filterOutFromAppSyncFilter}', filterOutFromAppSyncFilter);
    return positionFilterString;
  }

    private async _getDynamicFormAndType(): Promise<{ formDef: DynamicForm, formType: DynamicFormType }> {
      let accountForm: DynamicForm = await this.dynamicFormsService.getFormDefinitionForEntity("account", FormType.DISPLAYFORM);
      let formType = DynamicFormType.CONFIGUREDFORM;

      if (!accountForm) {
          accountForm = new DynamicForm(DefaultAccountDisplayForm['value'][0]);
          formType = DynamicFormType.DEFAULTFORM;
      }
      let formDef = accountForm;

      return { formDef, formType };
    }

    async _fetchGlobalSearchedAccountDetailsById(accountId: string) {
      // Fetch Account entity level details
      const fetchGlobalSearchAccountDetails = true;
      const fetchMultilingualFields:boolean = this.authService.user.securityRoles.some(a=> a.name == 'iO OneKey User' || a.name == 'iO OneKey Admin');
      let { formDef, formType } = await this._getDynamicFormAndType();
      let { parentEntityFetchXml, linkEntityAttributesArray } = await this._getAccountsConfiguredDisplayFetchXML(formDef, formType, true, null, accountId,fetchMultilingualFields);
      let response;

      try {
        response = await this.dynamics.executeFetchQuery('accounts',parentEntityFetchXml);
        if (Array.isArray(response) && response.length > 0) {
          response = response[0];
          let linkEntities = {};

          // Fetch extra link entity data
          if (Array.isArray(linkEntityAttributesArray)) {
            for (let i = 0; i < linkEntityAttributesArray.length; i++) {
              const linkEntity = linkEntityAttributesArray[i];
              const fetchMultilingualFields:boolean = this.authService.user.securityRoles.some(a=> a.name == 'iO OneKey User' || a.name == 'iO OneKey Admin');
              let { fetchXML } = this._getAccountsLinkedEntityFetchXML(linkEntity, accountId, null, null, formType,fetchMultilingualFields,fetchGlobalSearchAccountDetails);
              let linkEntityResponse: any[];

              let pagingInfo: any = null;
              let rawAllData = [];
      
              do {
                try {
                  let response = await this.dynamics.executeFetchXml(
                    this._getLinkedEntityCollectionName(linkEntity),
                    fetchXML,
                    undefined,
                    pagingInfo?.nextPage ?? 0,
                    pagingInfo?.cookie ?? null,
                  );
            
                  if (response) {
                    pagingInfo = response.PagingInfo ?? null;
                    
                    if (Array.isArray(response.value)) {
                      rawAllData.push(...response.value);
                    }
                  }
            
                } catch (error) {
                  console.log("Error retreiving linked entity data: ", error);
                  pagingInfo = null;
                  rawAllData = null;
                }
              } while (pagingInfo !== null);
            
              // mapping responses
              linkEntityResponse = rawAllData;          

              let dbKey: string = '';
              if (linkEntity.subgrid.referencingEntity === ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY) {
                dbKey = linkEntity.subgrid.relationshipName;
              } else {
                dbKey = linkEntity.subgrid.referencingEntity;
              }

              if (dbKey) {
                // A failed fetch leaves linkEntityResponse null; spreading it threw a
                // TypeError that aborted the whole loop, losing every remaining subgrid
                // rather than just the one that failed.
                linkEntities[DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + dbKey] = Array.isArray(linkEntityResponse) ? [...linkEntityResponse] : [];
              }
            }
          }
          response['globalSearchedDataLinkEntities'] = linkEntities;
        }
      } catch (error) {
        console.error('_fetchAccountDetailsById: entity info fetch', error);
      }

      return response;
    }

    public async _getAccountsFromDB(): Promise<any[]> {
      while (this._isDataPartitionWorkerBusy) {
        await this._accountsSaved;
      }
      const batchFetch = await this.disk.batchFetch(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_ACCOUNTS);
      if (!Array.isArray(batchFetch) || batchFetch.length === 0) {
        return [];
      }
      return batchFetch.reduce((acc: any[], element: any) => {
        const raw = element && element.raw;
        if (Array.isArray(raw)) {
          acc.push(...raw);
        }
        return acc;
      }, []);
    }

    // One run at a time: each run saves the whole list it read, so an overlapping run would save over newer data (OMNI-62878).
    public _doAccountsConfiguredDisplaySync(accountSyncInfo, interactionResponse, doFullSync, loadFromDB, lastUpdatedTime, accountId = null) {
      const run = this._accountsSyncLock.then(() => this._runAccountsConfiguredDisplaySync(accountSyncInfo, interactionResponse, doFullSync, loadFromDB, lastUpdatedTime, accountId));
      this._accountsSyncLock = run.catch(() => undefined);
      return run;
    }

    private async _runAccountsConfiguredDisplaySync(accountSyncInfo,interactionResponse,doFullSync,loadFromDB,lastUpdatedTime, accountId = null){
        this.accountLinkEntities = [];
        let { formDef, formType } = await this._getDynamicFormAndType();
        let forceFullSync = doFullSync;
        const accountsFromDB = await this._getAccountsFromDB();
        const offlineAccountMetadata = await this.disk.retrieve(DB_KEY_PREFIXES.ACCOUNT + '_metadata');
        const fetchMultilingualFields:boolean = this.authService.user.securityRoles.some(a=> a.name == 'iO OneKey User' || a.name == 'iO OneKey Admin');
        if(!accountId){
          if (fetchMultilingualFields && offlineAccountMetadata && offlineAccountMetadata.lastLocaleId && offlineAccountMetadata.lastLocaleId != this.authService.user.localeId) {
            this.localizationService.fullSyncRequiredForOnekeyCodes = true;
          }
          if (offlineAccountMetadata && offlineAccountMetadata.formType && offlineAccountMetadata.formType == DynamicFormType.DEFAULTFORM && formType == DynamicFormType.CONFIGUREDFORM) {
            forceFullSync = true;
            this.localizationService.fullSyncRequiredForOnekeyCodes = true;
            this.searchConfigService.resetConfiguredConfig('Accounts');
          } else if (offlineAccountMetadata && offlineAccountMetadata.formType && offlineAccountMetadata.formType == DynamicFormType.CONFIGUREDFORM && formType == DynamicFormType.DEFAULTFORM) {
            forceFullSync = true;
            this.localizationService.fullSyncRequiredForOnekeyCodes = true;
            this.searchConfigService.resetConfiguredConfig('Accounts');
          } else if (offlineAccountMetadata && offlineAccountMetadata.formType && offlineAccountMetadata.formType == DynamicFormType.CONFIGUREDFORM && offlineAccountMetadata.lastInitialSyncTime && this.dateService.isBeforeDate(new Date(offlineAccountMetadata.lastInitialSyncTime), new Date(formDef.modiefiedOn))) {
            forceFullSync = true;
            this.localizationService.fullSyncRequiredForOnekeyCodes = true;
            this.searchConfigService.resetConfiguredConfig('Accounts');
          }
        }

        forceFullSync = forceFullSync || this.secondaryInfoService.isAccountSecInfoUpdated;

        if(!this.searchConfigService.isConfigInitiated){
            this.searchConfigService.initSearchConfigs();
            this.searchConfigService.isConfigInitiated = true;
        }
        if((forceFullSync || !accountId)){
          this.searchConfigService.configUpdateRequired = true;
        }

        let { parentEntityFetchXml, linkEntityAttributesArray, hourDifference, positionFilterString } = await this._getAccountsConfiguredDisplayFetchXML(formDef, formType, forceFullSync, lastUpdatedTime, accountId,fetchMultilingualFields);

        let deletedAccountsRes;
        if(loadFromDB){
          await Promise.all([
            this.fetchAccountsLinkedEntityData(linkEntityAttributesArray, positionFilterString, hourDifference, formType, accountId, loadFromDB, fetchMultilingualFields),
            this.fetchAccountsDefaultLinkEntityData(positionFilterString, hourDifference, linkEntityAttributesArray, accountId, loadFromDB)
          ])
          this.accountOfflineService._mapAccounts(accountsFromDB);
          if (this.searchConfigService.configUpdateRequired) {
            this.searchConfigService.updateSearchConfigsForSelectedLanguage();
            this.searchConfigService.configUpdateRequired = false;
          }
        } else {
          return await this.dynamics.executeFetchQuery('accounts', parentEntityFetchXml).then(async (res) => {
            //Incase of linkEntity in secondary info cartisias product is available in response, hence iterate res and take which has all values in res
            let dataToSave = [];
            for(let val of res) {
              const index = dataToSave.findIndex(acc => acc.accountid === val.accountid);
              if(index >= 0) {
                if(entries(val).length > entries(dataToSave[index]).length) {
                  dataToSave[index] = val;
                }
              } else {
                dataToSave.push(val);
              }
            }
            res = dataToSave;
            let lastInitialSyncTime;
            if (!accountId) {
              accountSyncInfo.totalSynced = res.length;
            }
            const accountTags = isEmpty(res) ? null : await this.fetchAccountListPeriodTags(forceFullSync, lastUpdatedTime, accountId);
            if ((!forceFullSync || accountId) && Array.isArray(res)) {

              let localRaw = [...accountsFromDB];
              if (!accountId) {
                let posID = this.authService.user.xPositionID
                deletedAccountsRes = await this.fetchDeletedFromTrackChange("account", hourDifference, posID);
                if (deletedAccountsRes && Array.isArray(deletedAccountsRes)) {
                  let MDConfig = this.searchConfigService.accountConfiguredSearchIndexConfig.find(o => o.categoryName == 'MDM ID');
                  deletedAccountsRes.forEach(dRes => {
                    if (dRes) {
                      let MDMID;
                      let idx = localRaw.findIndex(a => a && a.hasOwnProperty('accountid') && a['accountid'] == dRes["indskr_entityid"]);
                      if (idx >= 0) {
                        MDMID = localRaw[idx].indskr_mdmid
                        localRaw.splice(idx, 1);
                      }
                      if (MDConfig && MDMID) {
                        MDConfig.values = MDConfig.values.filter(v => v != MDMID)
                      }
                    }
                  });
                }
              }

              lastInitialSyncTime = offlineAccountMetadata?.lastInitialSyncTime;
              res.forEach(rawRes => {
                if (rawRes) {
                  rawRes = omitBy(rawRes, (value, key) => key.endsWith('@OData.Community.Display.V1.AttributeName') 
                    ||  key.endsWith('@Microsoft.Dynamics.CRM.lookuplogicalname') 
                    ||  key.endsWith('_LogicalName')
                    );
                  let idx = localRaw.findIndex(a => a.accountid == rawRes.accountid);
                  if (idx >= 0) {
                    if (rawRes['statecode'] == 1 && (rawRes['statuscode'] == 2 || rawRes['statuscode'] == 548910003 || rawRes['statuscode'] == 548910010 || rawRes['statuscode'] == 548910011 || rawRes['statuscode'] == 548910012 || rawRes['statuscode'] == 548910013)) {
                      localRaw.splice(idx, 1);
                      if (this.accountOfflineService.selected && this.accountOfflineService.selected.id == rawRes.accountid && !this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag) {
                        this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag = true;
                      }
                    } else {
                      let foundDbAccount = localRaw[idx];
                      rawRes['interactionDate'] = foundDbAccount['interactionDate'];
                      rawRes['interactionType'] = foundDbAccount['interactionType'];
                      if (this.accountOfflineService.selected && this.accountOfflineService.selected.id == rawRes.accountid && !this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag) {
                        this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag = JSON.stringify(localRaw[idx]) != JSON.stringify(rawRes);
                      }
                      localRaw[idx] = rawRes;
                    }
                  } else {
                    if (rawRes['statuscode'] != 2 && rawRes['statuscode'] != 548910003 && rawRes['statuscode'] != 548910010 && rawRes['statuscode'] != 548910011 && rawRes['statuscode'] != 548910012 && rawRes['statuscode'] != 548910013) {
                      localRaw.push(rawRes);
                      rawRes['isNew'] = true;
                      if (this.accountOfflineService.selected && this.accountOfflineService.selected.id == rawRes.accountid && !this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag) {
                        this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag = true;
                      }
                      if (!accountsFromDB?.some(acc => acc.accountid === rawRes['accountid'])) {
                        this.deltaService.deltaRecordsDTO.accounts.push(rawRes['accountid']);
                      }
                    }
                  }
                }
              });
              if (this.deltaService.deltaRecordsDTO.accounts.length) {
                let displayName = this.deltaService.deltaRecordsDTO.accounts.length == 1 ? this.translate.instant("ACCOUNT") : this.translate.instant("ACCOUNTS");
                let showCount = this.deltaService.deltaRecordsDTO.accounts.length == 1 ? '' : this.deltaService.deltaRecordsDTO.accounts.length;
                this.accountsNotificationModel = {
                  type: NOTIFICATION.NEW_ACCOUNTS_NOTIFICATION,
                  name: this.translate.instant("NEW_ACCOUNTS_NOTIFICATION", {count: showCount, account: displayName}),
                  DateTime: Date.now(),
                  id: NOTIFICATION.NEW_ACCOUNTS_NOTIFICATION + this.deltaService.deltaRecordsDTO.accounts[0],
                  data: {
                    data: this.deltaService.deltaRecordsDTO.accounts
                  },
                  icon: 'assets/imgs/accounts_notification.svg',
                  isRed: false,
                  params: {count: showCount, account: displayName}
                }
                this.myAssistantService.saveNotificationToDisk(this.accountsNotificationModel); 
              }
              dataToSave = localRaw;
            } else {
              lastInitialSyncTime = new Date().getTime();
            }
            if (interactionResponse && dataToSave && dataToSave.length > 0) {
              await this.mapAccountWithInteraction(dataToSave, interactionResponse);
            }
            if (dataToSave && dataToSave.length > 0) {
              dataToSave = dataToSave.filter(con => !(con['statecode'] == 1 && (con['statuscode'] == 2 || con['statuscode'] == 548910003 || con['statuscode'] == 548910010 || con['statuscode'] == 548910011 || con['statuscode'] == 548910012 || con['statuscode'] == 548910013)));
              //If contact source is empty, mark it as business contacts
              dataToSave.forEach(data => {
                if (data.indskr_accountsourcetype == null) {
                  data['indskr_accountsourcetype'] = 548910000;
                  data['indskr_accountsourcetype@OData.Community.Display.V1.FormattedValue'] = "Business";
                  data['indskr_accountsourcetype_Formatted'] = "Business";
                }
                if (accountTags) {
                  if (accountTags[data['accountid']]) {
                    const tagLabels = [];
                    accountTags[data['accountid']].forEach(tag => {
                      if (tag['tagLabel']) {
                        tagLabels.push(tag['tagLabel']);
                      }
                    });
                    data['tagLabels'] = tagLabels;
                  }
                }
              });
            }
            // A single-account refresh with no server changes must not rewrite every account from its snapshot.
            const hasAccountChanges = !accountId || res.length > 0;
            if (hasAccountChanges) {
              // Use worker-based bucket saving for main account data (similar to contacts)
              this._postMessageOnDataPartitioner({
                type: 'partitionDatatoBuckets',
                rawList: dataToSave,
                num_buckets: this.authService.get_num_buckets(),
                bucket_key: DB_KEY_PREFIXES.ACCOUNT,
                hash_key: 'accountid' // Use accountid as hash key for bucketing
              });
            }
            
            // Save metadata separately (similar to how contacts handle it)
            await this.disk.updateOrInsert(DB_KEY_PREFIXES.ACCOUNT + '_metadata', doc => {
              doc = {
                lastInitialSyncTime: lastInitialSyncTime,
                lastLocaleId: this.authService.user.localeId,
                formType: formType,
              };
              return doc;
            }).catch(error => console.error('Save metadata to DB error: ', error));
            await Promise.all([this.fetchAccountsLinkedEntityData(linkEntityAttributesArray, positionFilterString, hourDifference, formType, accountId, loadFromDB, fetchMultilingualFields),
            this.fetchAccountsDefaultLinkEntityData(positionFilterString, hourDifference, linkEntityAttributesArray, accountId, loadFromDB)]);
            if (hasAccountChanges) {
              this.accountOfflineService._mapAccounts(dataToSave);
            }
            if (this.searchConfigService.configUpdateRequired) {
              this.searchConfigService.updateSearchConfigsForSelectedLanguage();
              this.searchConfigService.configUpdateRequired = false;
            }
            return res;
          }).catch(err => {
            if (!accountId) {
              this.deltaService.addSyncErrorToEntitySyncInfo(accountSyncInfo, 'accounts', err);
            }
          })
        }

    }

    private async fetchAccountListPeriodTags(forceFullSync, lastUpdatedTime, accountId) {
      if (!this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_LIST_MANAGEMENT)) return [];
      try {
        let fetchXml = ACCOUNT_LIST_PERIOD_TAG;
        const todayDate = this.dateService.formatDate(new Date(), "YYYY-MM-DD");
        let hourDifference;
        if (forceFullSync) {
          let initSyncFilter = '';
          if (!accountId) {
            initSyncFilter = `<filter type="and">
                <condition attribute="statecode" operator="eq" value="0" />
              </filter>`;
          }
          fetchXml = fetchXml.replace('{deltasyncFilterLevel1}', initSyncFilter);
        } else {
          let now = new Date();
          hourDifference = this.dateService.getDifferenceInHours(
            now,
            new Date(lastUpdatedTime)
          )
          //add one to make sure we take care of fractional difference in hours
          hourDifference += 1;
          let lastModifiedFilter = `<filter type="or">
              <condition attribute="modifiedon" operator="last-x-hours" value="`+ hourDifference + `" />
              <condition attribute="modifiedon" operator="last-x-hours" value="`+ hourDifference + `" entityname="indskr_customerpositionfilter"/>
            </filter>`

          if (accountId) {
            lastModifiedFilter = `<filter type="or">
                    <condition attribute="modifiedon" operator="last-x-hours" value="`+ hourDifference + `" />
                </filter>`
          }
          fetchXml = fetchXml.replace('{deltasyncFilterLevel1}', lastModifiedFilter);
        }

        let positionFilterString;
        if (accountId) {
          let accountIdFilter = `<filter type="and"><condition attribute="accountid" operator="eq" value="` + accountId + `" /></filter>`
          fetchXml = fetchXml.replace('{positionFilterlevel1}', '');
          fetchXml = fetchXml.replace('{customFilterLevel1}', accountIdFilter);
        } else {

          //create position filter
          let positionIds = this.authService.user.positions.map(o => {
            return o.ID
          });
          let positionIDValues = ''
          positionIds.forEach(p => {
            positionIDValues += '<value>' + p + '</value>'
          })
          positionFilterString = AccountsPositionFilter.split('{positionIDs}').join(positionIDValues);
          const approvalStatusFilter = this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_VISIBILITY_APPROVAL_BASED)
            ? `<filter type="or">
                <condition attribute="indskr_approvalstatus" operator="eq" value="548910002" />
                <condition attribute="indskr_approvalstatus" operator="null"/>
              </filter>`
            : '';
          positionFilterString = positionFilterString.replace('{approvalStatusFilter}', approvalStatusFilter);
          fetchXml = fetchXml.replace('{positionFilterlevel1}', positionFilterString);
          fetchXml = fetchXml.replace('{customFilterLevel1}', '');
        }
        fetchXml = fetchXml.replace('{secondaryInfoPlaceholder}', '').split('{date}').join(todayDate).replace('{positionId}', this.authService.user.xPositionID);;
        const accountTags = await this.dynamics.executeFetchQuery('accounts', fetchXml);
        return groupBy(accountTags, (item) => item['accountid']);
      } catch (error) {
        console.error("Failed to fetch account list period tags: ", error);
      }
      return [];
    }

    async fetchDeletedFromTrackChange(entity, hourDifference: any,primaryPositionID?:string ){
      try{
          let res = [];
          let fetchXML = `
              <fetch version="1.0" output-format="xml-platform" mapping="logical" distinct="true">
                  <entity name="indskr_trackchange">
                      <attribute name="createdon"/>
                      <attribute name="indskr_action"/>
                      <attribute name="indskr_entityid"/>
                      <filter type="and">
                          <condition attribute="createdon" operator="last-x-hours" value="`+ hourDifference+`" />
                          <condition value="` + entity  + `" attribute="indskr_entityname" operator="eq" />
                          <condition value="548910001" attribute="indskr_action" operator="eq" />
                          {positionIDFilter}
                      </filter>
                  </entity>
              </fetch>`
              if(!primaryPositionID){
                fetchXML = fetchXML.replace('{positionIDFilter}','')
              }
              else{
                let positionCondition = '<condition value="'+primaryPositionID+'" attribute="indskr_positionid" operator="eq" />'
                fetchXML = fetchXML.replace('{positionIDFilter}',positionCondition);
              }
          res = await this.dynamics.executeFetchQuery('indskr_trackchanges',fetchXML)
          return res
      } catch (error){
          console.log(error)
      }
    }

    /**
     * `isFetchGlobalSearchAccountDetails` and `includeAffiliationsBeyondPosition` are
     * deliberately SEPARATE, though every current caller passes the same value for both.
     * They answer different questions: the first is "is this a one-off detail fetch, so
     * no delta bound applies", the second is "may affiliation link-entities reach past
     * the rep's position tree". A single flag carried both meanings until now, and that
     * is how commit fe0a039eab - which only meant to stop FULL SYNC pulling affiliations
     * irrespective of position - silently re-applied the position filter to the
     * real-time path two days after 0a58838ec69 had deliberately dropped it. Changing
     * one behaviour must not move the other.
     */
    private _getAccountsLinkedEntityFetchXML(linkEntity, accountid, positionFilterString, hourDifference, dynamicFormType,fetchMultilingualFields:boolean = false,isFetchGlobalSearchAccountDetails = false, includeAffiliationsBeyondPosition = isFetchGlobalSearchAccountDetails) {
        let searchCategory: searchIndexDataModel;

        this.accountLinkEntities.push(linkEntity.subgrid.referencingEntity);
        //#region fetchxml replace
        let fetchXML = linkEntity.subgrid.referencingEntity === ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY ? fetchQueries.configuredFormFetchXMLs.fetchConfiguredFormEntityPagingACAff : fetchQueries.configuredFormFetchXMLs.fetchConfiguredFormEntityPaging;
        fetchXML = fetchXML.replace('{linkEntityPlaceholder}', linkEntity.subgrid.referencingEntity === ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY ? fetchQueries.configuredFormFetchXMLs.linkEntityPlaceholderACAff : fetchQueries.configuredFormFetchXMLs.linkEntityPlaceholder);
        fetchXML = fetchXML.replace('{parentEntityName}', 'account');
        fetchXML = fetchXML.replace('{parentLevelAttributes}', '<attribute name="accountid"/>');
        fetchXML = fetchXML.replace('{linkEntityName}', linkEntity.subgrid.referencingEntity);
        fetchXML = fetchXML.replace('{linkEntityAttr}', linkEntity.subgrid.referencingAttribute);
        fetchXML = fetchXML.replace('{prentEntityAttr}', linkEntity.subgrid.parentAttribute);
        fetchXML = fetchXML.replace('{linkEntityAlias}', linkEntity.subgrid.referencingEntity);
        fetchXML = fetchXML.replace('{ParentEntityAlias}', 'account');
        fetchXML = fetchXML.replace('{customFilterLevel2}', '');
        fetchXML = fetchXML.replace('{secondaryInfoPlaceholder}','');

        // Filter---

        // Address---> isPrimary

        if(accountid) {
            let accountidfilter = `<filter type="and"><condition attribute="accountid" operator="eq" value="` + accountid + `" /></filter>`
            fetchXML = fetchXML.replace('{customFilterLevel1}', accountidfilter);
            fetchXML = fetchXML.replace('{positionFilterlevel1}', '');
        } else {
            fetchXML = fetchXML.replace('{positionFilterlevel1}', positionFilterString);
            fetchXML = fetchXML.replace('{customFilterLevel1}', '');
        }
        if(isFetchGlobalSearchAccountDetails){
          fetchXML = fetchXML.replace('{deltasyncFilterLevel1}', '');
          fetchXML = fetchXML.replace('{deltasyncFilterLevel2}', '');
        }
        else if (hourDifference && !accountid) {
          let lastModifiedFilter =
              `<filter type="or">
              <condition attribute="modifiedon" operator="last-x-hours" value="`+ hourDifference + `" entityname="`+linkEntity.subgrid.referencingEntity+`"/>
              <condition attribute="modifiedon" operator="last-x-hours" value="`+ hourDifference + `" entityname="indskr_customerpositionfilter"/>
            </filter>`
          fetchXML = fetchXML.replace('{deltasyncFilterLevel1}', lastModifiedFilter);
          fetchXML = fetchXML.replace('{deltasyncFilterLevel2}', '');
      }
      // No modified on filter for intial sync
      else if(!hourDifference && !accountid){
          fetchXML = fetchXML.replace('{deltasyncFilterLevel1}', '');
          fetchXML = fetchXML.replace('{deltasyncFilterLevel2}', '');
      }
      // Modified on filter for usual real time details fetch - filter at only linked entity level
      else {
        // `hourDifference` is only assigned on the delta branch of
        // _getAccountsConfiguredDisplayFetchXML; a full sync leaves it undefined and
        // still passes it down here. Interpolating it emitted
        // value="undefined", which Dynamics rejects outright —
        // 0x80041139 "Attribute 'value' must be a valid integer for condition
        // operator: LastXHours" — so the whole linked-entity fetch 400s and the
        // caller silently gets nothing (a real-time account fetch then rendered no
        // affiliations at all until some other path populated them).
        // No delta bound is the correct behaviour for a full sync anyway: fetch
        // everything for this record rather than everything changed since an
        // unknown time.
        let lastModifiedFilter = hourDifference
          ? `<filter type="or">
              <condition attribute="modifiedon" operator="last-x-hours" value="`+ hourDifference + `"/>
            </filter>`
          : '';
          fetchXML = fetchXML.replace('{deltasyncFilterLevel1}', '');
          fetchXML = fetchXML.replace('{deltasyncFilterLevel2}', lastModifiedFilter);
      }
        //#endregion

        //check if it linkentity is also a mandatory data
        let requiredLinkEntity = FETCH_ACCOUNT_DEFAULT_LINK_ENTITES.find(x => x.entityName == linkEntity.subgrid.referencingEntity)
        let shouldMerge = false;
        let requiredJSONQuery;
        if (requiredLinkEntity) {
            if (requiredLinkEntity.entityFetchXML) {
                shouldMerge = true;
                XML2JS.parseString(requiredLinkEntity.entityFetchXML, (err, data) => {
                    requiredJSONQuery = data;
                })
            }
        }

        //generate attributes list and next level link-entities
        let queryString = linkEntity.subgrid.subgridQuery;
        let JSONQuery;
        let linkEntityAttributesStr = '';
        let uniqueAttributes = new Set<string>(); // Track unique attributes to prevent duplicates
        
        // Helper function to add unique attributes
        const addUniqueAttribute = (attributeStr: string) => {
            if (!uniqueAttributes.has(attributeStr)) {
                uniqueAttributes.add(attributeStr);
                linkEntityAttributesStr += attributeStr;
            }
        };
        
        XML2JS.parseString(queryString, (err, data) => {
            JSONQuery = data;
        })
        let multilingualAttributes = [];
        if(fetchMultilingualFields && linkEntity.subgrid && linkEntity.subgrid.subgridLayout && linkEntity.subgrid.subgridLayout.length > 0){
          multilingualAttributes = linkEntity.subgrid.subgridLayout.filter(a=> a.targetEntity && a.targetEntity == 'omnione_onekeycodeslabels').map(a=> a.attribute);
        }
        JSONQuery.fetch.entity[0].attribute.forEach(attr => {
          let idx;
          if (multilingualAttributes.length > 0) {
            idx = multilingualAttributes.findIndex(a => a == attr.$.name);
          }
          if (idx >= 0) {
            this.localizationService.multiLingualAttributes.push(attr.$.name);
            addUniqueAttribute('<attribute name="' + attr.$.name + '" ' +
            this.getAlias(linkEntity.subgrid.referencingEntity, attr.$.name) + '/>');
          } else {
            addUniqueAttribute('<attribute name="' + attr.$.name + '" ' +
            this.getAlias(linkEntity.subgrid.referencingEntity, attr.$.name) + '/>');
          }
        });

        let numOfLinkEntity = 0; //keep track the number of link entity. Needed for building global search fetchxml
        //Do it for the required data
        if (shouldMerge) {
            requiredJSONQuery.fetch.entity[0].attribute.forEach(attr => {
                addUniqueAttribute('<attribute name="' + attr.$.name + '" ' +
                this.getAlias(linkEntity.subgrid.referencingEntity, attr.$.name) + '/>');
            });
            if (JSONQuery.fetch.entity[0]['link-entity'] && JSONQuery.fetch.entity[0]['link-entity'].length) {
                JSONQuery.fetch.entity[0]['link-entity'].forEach(linEnt => {
                    numOfLinkEntity ++;
                    try {
                        linkEntityAttributesStr += "<link-entity name='" + linEnt.$.name + "' from='" + linEnt.$.from + "' to='"
                        + linEnt.$.to + "' link-type='outer' alias='" + linEnt.$.name + "'>";

                        linEnt.attribute.forEach(linEntAttr => {
                            addUniqueAttribute('<attribute name="' + linEntAttr.$.name + '" ' +
                            this.getAlias(linkEntity.subgrid.referencingEntity, linEntAttr.$.name) + '/>');
                        });

                        if (Array.isArray(requiredJSONQuery.fetch.entity[0]['link-entity'])) {
                            let reqLE = requiredJSONQuery.fetch.entity[0]['link-entity'].find(x => x.$.name == linEnt.$.name);
                            if (reqLE && reqLE.attribute) {
                                reqLE.attribute.forEach(reqLinEntAttr => {
                                    if (!linEnt.attribute.some(x => x.$.name == reqLinEntAttr.$.name)) {
                                        addUniqueAttribute('<attribute name="' + reqLinEntAttr.$.name + '" ' +
                                        this.getAlias(linkEntity.subgrid.referencingEntity, reqLinEntAttr.$.name) + '/>');
                                    }
                                });
                            }
                        }
                        linkEntityAttributesStr += "</link-entity>"
                    } catch (error) {
                        console.log(error);
                    }
                });
            }

            //now iterate through the filter and append the filter criteria defined in the
            //Order attribute not required for account-contact-aff because with this it doesn't fetch if more than 10 pages
          if(linkEntity.subgrid.referencingEntity !== ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY) 
            linkEntityAttributesStr = this.dynamicFormsService.appendSortCriteria(JSONQuery, linkEntityAttributesStr);
          linkEntityAttributesStr = this.dynamicFormsService.appendFilterCriteria(JSONQuery, linkEntityAttributesStr);
          //now iterate through the filter and append the sort criteria defined in the

            if (requiredJSONQuery.fetch.entity[0]['link-entity'] && requiredJSONQuery.fetch.entity[0]['link-entity'].length) {
                requiredJSONQuery.fetch.entity[0]['link-entity'].forEach(linEnt => {
                    numOfLinkEntity ++;
                    try {
                        if (Array.isArray(JSONQuery.fetch.entity[0]['link-entity']) && JSONQuery.fetch.entity[0]['link-entity'].some(x => x.$.name == linEnt.$.name)) return;

                        linkEntityAttributesStr += "<link-entity name='" + linEnt.$.name + "' from='" + linEnt.$.from + "' to='"
                            + linEnt.$.to + "' link-type='outer' alias='" + linEnt.$.name + "'>";

                        if(linEnt.attribute) {
                            linEnt.attribute.forEach(linEntAttr => {
                              addUniqueAttribute('<attribute name="' + linEntAttr.$.name + '" ' +
                                this.getAlias(linkEntity.subgrid.referencingEntity, linEntAttr.$.name) + '/>');
                            });
                        }
                        linkEntityAttributesStr += "</link-entity>"
                    } catch (error) {
                        console.log(error);
                    }
                });
            }
        } else {
            // if no reqired data
            if (JSONQuery.fetch.entity[0]['link-entity'] && JSONQuery.fetch.entity[0]['link-entity'].length) {
                JSONQuery.fetch.entity[0]['link-entity'].forEach(linEnt => {
                    numOfLinkEntity ++;
                    try {
                        linkEntityAttributesStr += "<link-entity name='" + linEnt.$.name + "' from='" + linEnt.$.from + "' to='"
                        + linEnt.$.to + "' link-type='outer' alias='" + linEnt.$.name + "'>";
                        if(linEnt.attribute) {
                            linEnt.attribute.forEach(linEntAttr => {
                                addUniqueAttribute('<attribute name="' + linEntAttr.$.name + '" ' +
                                this.getAlias(linkEntity.subgrid.referencingEntity, linEntAttr.$.name) + '/>');
                            });
                        }

                        linkEntityAttributesStr += "</link-entity>"
                    } catch (error) {
                        console.log(error);
                    }

                });
        }
          linkEntityAttributesStr = this.dynamicFormsService.appendSortCriteria(JSONQuery, linkEntityAttributesStr);
          linkEntityAttributesStr = this.dynamicFormsService.appendFilterCriteria(JSONQuery, linkEntityAttributesStr);
        }
        let globalSearchFetch = linkEntity.subgrid.referencingEntity === ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY ? fetchQueries.configuredFormFetchXMLs.linkEntityPlaceholderACAff : fetchQueries.configuredFormFetchXMLs.linkEntityPlaceholder;
        globalSearchFetch = globalSearchFetch.replace('{linkEntityName}', linkEntity.subgrid.referencingEntity);
        globalSearchFetch = globalSearchFetch.replace('{linkEntityAttr}', linkEntity.subgrid.referencingAttribute);
        globalSearchFetch = globalSearchFetch.replace('{prentEntityAttr}', linkEntity.subgrid.parentAttribute);
        globalSearchFetch = globalSearchFetch.replace('{linkEntityAlias}', linkEntity.subgrid.referencingEntity);
        globalSearchFetch = globalSearchFetch.replace('{customFilterLevel2}', '');
        globalSearchFetch = globalSearchFetch.replace('{deltasyncFilterLevel2}', '');
        globalSearchFetch = globalSearchFetch.replace('{linkEntityAttributes}', linkEntityAttributesStr);

        if (linkEntity.isSearchable && linkEntity.searchAttributeName) {
            const refEntityNamesToBeAggregated = [
              ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY,
            ];
            let idx = this.searchConfigService.accountConfiguredSearchIndexConfig.findIndex(conf=> conf.categoryRelativePath == linkEntity.searchAttributeName);
            if(idx >= 0) {
                let tempConfig = this.searchConfigService.accountConfiguredSearchIndexConfig[idx];
                tempConfig.linkEntityFetchXML = globalSearchFetch;
                searchCategory = this.searchConfigService.accountConfiguredSearchIndexConfig[idx];
            } else {
                const isThisToBeAggregated = refEntityNamesToBeAggregated.includes(linkEntity.subgrid.referencingEntity);
                let categoryName: string = isThisToBeAggregated
                      ? this.getAggregatedCategoryName(linkEntity)
                      : this.dynamicFormsService.getSearchConfigDisplayText(linkEntity.displayNames, dynamicFormType, linkEntity.isCustom);
                let multiLingualSearchAttribute = linkEntity.searchAttributeName.split('.');
                searchCategory = {
                    categoryName,
                    categoryDisplayName: categoryName,
                    controlDataType: 'LinkedEntity',
                    categoryRelativePath: linkEntity.searchAttributeName,
                    values: [],
                    mappingValues: [],
                    parentEntity: linkEntity.subgrid.referencingEntity,
                    entity: linkEntity.subgrid.referencingEntity,
                    linkEntityFetchXML: globalSearchFetch,
                    numOfLinkEntity:  numOfLinkEntity,
                    fromAttribute: linkEntity.subgrid.referencingAttribute,
                    toAttribute: linkEntity.subgrid.parentAttribute,
                    isThisToBeAggregated,
                    relationshipName: linkEntity.subgrid.relationshipName ?? '',
                    isMultilingualLookup: multilingualAttributes.some(a=> a == multiLingualSearchAttribute[1]),
                };
                this.searchConfigService.accountConfiguredSearchIndexConfig.push(searchCategory);
            }
        }

        addUniqueAttribute(`<attribute name="statecode"/>`);
        addUniqueAttribute(`<attribute name="statuscode"/>`);
        // if linkEntity.subgrid.subgridQuery has statecode condition, deactivated data does not update
        linkEntityAttributesStr = linkEntityAttributesStr.replace('<condition attribute=\"statecode\" operator=\"eq\" value=\"0\"/>', '');
        
        /*
        1. Fetch from-account-account affiliation: fetch data if to-account is mapped to the current user's positions/parent positions
        2. Fetch to-account-account affiliation: fetch data if from-account is mapped to the current user's positions/parent positions
        3. Fetch contact-account affiliation: fetch data if contact is mapped to the current user's positions/parent positions
        */
        if (!includeAffiliationsBeyondPosition && (linkEntity.subgrid.referencingEntity == 'indskr_accountaccountaffiliation' || linkEntity.subgrid.referencingEntity == 'indskr_accountcontactaffiliation')) {
          let toAttribute;
          if (linkEntity.subgrid.referencingAttribute == 'indskr_affiliatedtoaccountid') {
            toAttribute = 'indskr_affiliatedfromaccountid';
          } else if (linkEntity.subgrid.referencingAttribute == 'indskr_affiliatedfromaccountid') {
            toAttribute = 'indskr_affiliatedtoaccountid';
          } else if (linkEntity.subgrid.referencingEntity == 'indskr_accountcontactaffiliation') {
            toAttribute = 'indskr_contactid';
          }
          const customPositionFilterString = this.getPositionFilterString(true, toAttribute);
          fetchXML = fetchXML.replace('{linkEntityAttributes}', customPositionFilterString + '' + linkEntityAttributesStr);
        }
        else {
          fetchXML = fetchXML.replace('{linkEntityAttributes}', linkEntityAttributesStr);
        }
        return { fetchXML, searchCategory };
    }

    private getAlias(referencingEntity: string, attributeName: string) {
      return referencingEntity === ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY ? 'alias="' + referencingEntity + '.' + attributeName + '"'
        : '';
    }

    private getAggregatedCategoryName(linkEntity: Control): string {
      let categoryName: string = '';
      if (linkEntity) {
        if (linkEntity.subgrid?.referencingEntity === ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY) {
          categoryName = 'ACCOUNT_AFFILIATIONS';
        }

        categoryName = this.translate.instant(categoryName);
      }

      return categoryName;
    }


    private async fetchAccountsLinkedEntityData(linkedEntityDefArray: Control[], positionFilterString, hourDifference, dynamicFormType:DynamicFormType, accountid, loadFromDB, fetchMultilingualFields:boolean = false,isFetchGlobalSearchAccountDetails = false, includeAffiliationsBeyondPosition = isFetchGlobalSearchAccountDetails ) {
      
      return Promise.all(linkedEntityDefArray.map(async (linkEntity)=>{
        let { fetchXML, searchCategory } = this._getAccountsLinkedEntityFetchXML(linkEntity, accountid, positionFilterString, hourDifference, dynamicFormType,fetchMultilingualFields,isFetchGlobalSearchAccountDetails, includeAffiliationsBeyondPosition);
            if(loadFromDB) {
                // Try to retrieve from chunks first, then fall back to regular retrieve
                let rawData = await this.disk.retrieveFromChunks(linkEntity.subgrid.referencingEntity);
                if (!rawData) {
                  // Fall back to old non-chunked format
                  let temp = await this.disk.retrieve(linkEntity.subgrid.referencingEntity);
                  if(temp && temp.raw) {
                    rawData = temp.raw;
                  }
                }
                if(rawData) {
                  if(searchCategory){
                    searchCategory.values = [];
                    searchCategory.mappingValues = [];
                    this.mapLinkEntityToSearch(linkEntity, searchCategory, rawData);
                  }
                }
            }else{
              let pagingInfo: any = null;
              let rawAllData = [];
      
              do {
                try {
                  if (isEmpty(rawAllData))
                  {
                  }
                  let response = await this.dynamics.executeFetchXml(
                    linkEntity.subgrid.referencingEntity === ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY ? 'indskr_accountcontactaffiliations' : 'accounts',
                    fetchXML,
                    undefined,
                    pagingInfo?.nextPage ?? 0,
                    pagingInfo?.cookie ?? null,
                  );
            
                  if (response) {
                    pagingInfo = response.PagingInfo ?? null;
                    
                    if (Array.isArray(response.value)) {
                      rawAllData.push(...response.value);
                    }
                  }
            
                } catch (error) {
                  console.log("Error retreiving linked entity data: ", error);
                  pagingInfo = null;
                  rawAllData = null;
                }
              } while (pagingInfo !== null);
              if (!Array.isArray(rawAllData)) {
                // Fetch failed on every retry attempt - bail out for this linked entity rather than
                // operating on a null array, preserving whatever data is already stored locally.
                console.error(`fetchAccountsLinkedEntityData: failed to fetch ${linkEntity.subgrid.referencingEntity}, skipping this sync cycle`);
                return;
              }
              if (linkEntity.subgrid.referencingEntity === ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY) {
                // For indskr_accountcontactaffiliation, change 'account.accountid' to 'accountid' in each item
                rawAllData.forEach(rawRes => {
                  if (rawRes && rawRes.hasOwnProperty('account.accountid')) {
                    rawRes['accountid'] = rawRes['account.accountid'];
                  }
                });
              }
              // mapping responses 
              let dataToSave = rawAllData.map(rawRes => omitBy(rawRes, (value, key) => key.endsWith('@OData.Community.Display.V1.AttributeName')
                || key.endsWith('@Microsoft.Dynamics.CRM.lookuplogicalname')
                || key.endsWith('_LogicalName')
                ));
              let dbKey: string = '';
              if (linkEntity.subgrid.referencingEntity === ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY) {
                dbKey = linkEntity.subgrid.relationshipName;
              } else {
                dbKey = linkEntity.subgrid.referencingEntity;
              }
              if ((hourDifference || accountid) && Array.isArray(rawAllData)) {
                  // Try to retrieve from chunks first, then fall back to regular retrieve
                  let localRaw = await this.disk.retrieveFromChunks(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + dbKey);
                  if (!localRaw) {
                    // Fall back to old non-chunked format
                    let temp = await this.disk.retrieve(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + dbKey);
                    if (temp && temp.raw) {
                      localRaw = temp.raw;
                    }
                  }
                  let leIdAttrName = linkEntity.subgrid.referencingEntity + "." + linkEntity.subgrid.referencingEntity + "id";
                  if (localRaw) {
                      rawAllData.forEach(rawRes => {
                          if (rawRes && rawRes.hasOwnProperty('accountid') && rawRes.hasOwnProperty('accountid') && rawRes[leIdAttrName]) {
                              let idx = localRaw.findIndex(a => a && a.hasOwnProperty('accountid') && a[leIdAttrName] == rawRes[leIdAttrName]);
                              if(this.accountOfflineService.selected && this.accountOfflineService.selected.id == rawRes.accountid && !this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag){
                                if(idx >= 0){
                                  this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag = this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag = JSON.stringify(localRaw[idx]) != JSON.stringify(rawRes);
                                }else{
                                  this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag = true;
                                }
                              }
                              if (idx >= 0) {
                                if ((rawRes['statecode'] == 1 && rawRes['statuscode'] == 2) || (rawRes[linkEntity.subgrid.referencingEntity+'.statecode'] == 1 && rawRes[linkEntity.subgrid.referencingEntity+'.statuscode'] == 2)) {
                                      localRaw.splice(idx, 1);
                                  } else {
                                      localRaw[idx] = rawRes;
                                  }
                              } else {
                                if (rawRes['statuscode'] != 2 && rawRes[linkEntity.subgrid.referencingEntity+'.statuscode'] != 2) {
                                      localRaw.push(rawRes);
                                  }
                              }
                          }
                      });
                      dataToSave = localRaw;
                  }
              }
              
              // Use worker to batch and save data to prevent app crashes with large datasets.
              // Single-account fetches bypass the async worker so PouchDB is updated before
              // the renderer reads (avoids stale data on re-render after realtime refresh).
              if (Array.isArray(dataToSave) && dataToSave.length > 0) {
                if (accountid) {
                  const dbKeyWithPrefix = DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + dbKey;
                  // Was a bare updateOrInsert, which writes the single-document shape only.
                  // Once this key had grown past the chunk threshold, every reader that checks
                  // chunks first kept serving the pre-existing chunks and this write was never
                  // seen - a single-account refresh silently did nothing.
                  await this.disk.saveLinkedEntityData(dbKeyWithPrefix, dataToSave);
                } else {
                  this._postMessageOnLinkedEntityWorker(dbKey, dataToSave, DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY);
                }
              }
              if(searchCategory){
                searchCategory.values = [];
                searchCategory.mappingValues = [];
                this.mapLinkEntityToSearch(linkEntity, searchCategory, dataToSave);
              }
            }
      }));
        // To Do purge of unused account linked entities

    }

    /**
     * Entity-set name to post a linked-entity fetch to. The account-contact affiliation
     * query (fetchConfiguredFormEntityPagingACAff) is rooted at the affiliation entity
     * rather than at account, so it has to go to that entity's own collection - posting it
     * to /accounts makes Dynamics reject the request outright. The periodic sync path has
     * always picked the collection this way; the two global-search paths hardcoded
     * 'accounts', so affiliated contacts silently never came back for an account opened
     * from global search.
     */
    private _getLinkedEntityCollectionName(linkEntity): string {
      return linkEntity.subgrid.referencingEntity === ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY
        ? 'indskr_accountcontactaffiliations'
        : 'accounts';
    }

    /**
     * Every contact affiliated to one account, fetched live and NOT filtered by the rep's
     * position. Backs the BU_ACCOUNT_GA_ALLAFFILIATEDCONTACTS display option.
     *
     * Nothing is written to local storage - these rows live only for as long as the account
     * page is open. That is the whole point of the option: it adds no rows to the periodic
     * sync, no rows to PouchDB and no rows to the advanced-search index, so sync volume and
     * app startup are untouched no matter how many affiliations an account carries.
     *
     * Returns null when the fetch fails or the rep is offline, so the caller can leave the
     * position-scoped rows from local storage in place rather than blanking the subgrid.
     */
    public async fetchAllAffiliatedContactsForAccount(accountId: string): Promise<any[] | null> {
      if (!accountId || this.device.isOffline) return null;
      try {
        const fetchMultilingualFields: boolean = this.authService.user.securityRoles.some(a => a.name == 'iO OneKey User' || a.name == 'iO OneKey Admin');
        const { formDef, formType } = await this._getDynamicFormAndType();
        const { linkEntityAttributesArray } = await this._getAccountsConfiguredDisplayFetchXML(formDef, formType, true, null, accountId, fetchMultilingualFields);
        if (!Array.isArray(linkEntityAttributesArray)) return null;

        const linkEntity = linkEntityAttributesArray.find(le => le?.subgrid?.referencingEntity === ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY);
        // The affiliated-contacts subgrid isn't on this org's account display form.
        if (!linkEntity) return null;

        // includeAffiliationsBeyondPosition = true is what drops the contact position filter
        // (passed explicitly alongside isFetchGlobalSearchAccountDetails rather than
        // relying on its default, so this call keeps working if the two ever diverge)
        // (see _getAccountsLinkedEntityFetchXML) and the delta-sync filter, leaving an
        // account-id filter alone - exactly the query this option needs.
        const { fetchXML } = this._getAccountsLinkedEntityFetchXML(linkEntity, accountId, null, null, formType, fetchMultilingualFields, true, true);
        const collection = this._getLinkedEntityCollectionName(linkEntity);

        let pagingInfo: any = null;
        const rows: any[] = [];
        do {
          const response = await this.dynamics.executeFetchXml(
            collection,
            fetchXML,
            undefined,
            pagingInfo?.nextPage ?? 0,
            pagingInfo?.cookie ?? null,
          );
          pagingInfo = response?.PagingInfo ?? null;
          if (Array.isArray(response?.value)) rows.push(...response.value);
        } while (pagingInfo !== null);

        // The sync path copies 'account.accountid' onto 'accountid', and the display form
        // filters every subgrid row on that key - so the live rows have to carry it too or
        // they are all filtered out before rendering.
        rows.forEach(row => {
          if (row && row.hasOwnProperty('account.accountid')) row['accountid'] = row['account.accountid'];
        });

        return rows.map(row => omitBy(row, (value, key) => key.endsWith('@OData.Community.Display.V1.AttributeName')
          || key.endsWith('@Microsoft.Dynamics.CRM.lookuplogicalname')
          || key.endsWith('_LogicalName')));
      } catch (error) {
        console.error('fetchAllAffiliatedContactsForAccount failed for accountId=', accountId, error);
        return null;
      }
    }

    /**
     * BU_AFFILIATION_GA_VISIBILITY accountform.affiliatedAccountsOnline = 'all': the complete
     * live list of account-to-account affiliations for this account, in BOTH directions,
     * ignoring whether the counterpart account is in the rep's position.
     *
     * The position sync deliberately requires the counterpart to be in position too (see the
     * comment on the secondary position filter in _getAccountsLinkedEntityFetchXML), which is
     * why a department affiliated to an out-of-territory hospital shows nothing offline. This
     * is the online escape hatch, mirroring fetchAllAffiliatedContactsForAccount.
     *
     * Returns a map keyed by relationshipName - NOT by referencingEntity. Both directions
     * share one referencingEntity, and ind-display-form resolves its in-memory override by
     * referencingEntity first, so a single key would feed the same rows to both merged
     * controls and double every card.
     *
     * null means offline or the request failed, so the caller can leave stored rows alone.
     */
    public async fetchAllAffiliatedAccountsForAccount(accountId: string): Promise<{ [relationshipName: string]: any[] } | null> {
      if (!accountId || this.device.isOffline) return null;
      try {
        const fetchMultilingualFields: boolean = this.authService.user.securityRoles.some(a => a.name == 'iO OneKey User' || a.name == 'iO OneKey Admin');
        const { formDef, formType } = await this._getDynamicFormAndType();
        const { linkEntityAttributesArray } = await this._getAccountsConfiguredDisplayFetchXML(formDef, formType, true, null, accountId, fetchMultilingualFields);
        if (!Array.isArray(linkEntityAttributesArray)) return null;

        const linkEntities = linkEntityAttributesArray.filter(
          le => le?.subgrid?.referencingEntity === ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY && le?.subgrid?.relationshipName,
        );
        // The account-account subgrids are not on this org's account display form.
        if (!linkEntities.length) return null;

        const result: { [relationshipName: string]: any[] } = {};
        for (const linkEntity of linkEntities) {
          // includeAffiliationsBeyondPosition = true drops the counterpart position filter and
          // the delta bound, leaving an account-id filter alone.
          const { fetchXML } = this._getAccountsLinkedEntityFetchXML(linkEntity, accountId, null, null, formType, fetchMultilingualFields, true, true);
          const collection = this._getLinkedEntityCollectionName(linkEntity);

          let pagingInfo: any = null;
          const rows: any[] = [];
          do {
            const response = await this.dynamics.executeFetchXml(
              collection,
              fetchXML,
              undefined,
              pagingInfo?.nextPage ?? 0,
              pagingInfo?.cookie ?? null,
            );
            pagingInfo = response?.PagingInfo ?? null;
            if (Array.isArray(response?.value)) rows.push(...response.value);
          } while (pagingInfo !== null);

          // ind-display-form filters every subgrid row on this key, so live rows must carry it.
          rows.forEach(row => {
            if (row && row.hasOwnProperty('account.accountid')) row['accountid'] = row['account.accountid'];
            if (row && !row['accountid']) row['accountid'] = accountId;
          });

          result[linkEntity.subgrid.relationshipName] = rows.map(row => omitBy(row, (value, key) => key.endsWith('@OData.Community.Display.V1.AttributeName')
            || key.endsWith('@Microsoft.Dynamics.CRM.lookuplogicalname')
            || key.endsWith('_LogicalName')));
        }
        return result;
      } catch (error) {
        console.error('fetchAllAffiliatedAccountsForAccount failed for accountId=', accountId, error);
        return null;
      }
    }

    public async fetchUnmappedAccountsLinkedEntityData(accountId: string, onlyReferencingEntities?: string[]){
      const fetchGlobalSearchAccountDetails = true;
      const fetchMultilingualFields:boolean = this.authService.user.securityRoles.some(a=> a.name == 'iO OneKey User' || a.name == 'iO OneKey Admin');
      let { formDef, formType } = await this._getDynamicFormAndType();
      let { linkEntityAttributesArray } = await this._getAccountsConfiguredDisplayFetchXML(formDef, formType, true, null, accountId,fetchMultilingualFields);
      let linkEntities = {};
      if (Array.isArray(linkEntityAttributesArray)) {
        for (let i = 0; i < linkEntityAttributesArray.length; i++) {
          const linkEntity = linkEntityAttributesArray[i];
          const isAffiliationSubgrid = linkEntity.subgrid.referencingEntity== ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY ||
              linkEntity.subgrid.referencingEntity== ACCOUNT_CONTACT_AFFILIATIONS_REF_ENTITY ||
              linkEntity.subgrid.referencingEntity== "indskr_accountbrandaffiliation";
          // onlyReferencingEntities narrows the fetch to specific subgrids. The all-affiliated-
          // contacts feature wants the contact affiliation alone and would otherwise pay for
          // two extra live requests it never reads.
          const isRequested = !onlyReferencingEntities
            || onlyReferencingEntities.includes(linkEntity.subgrid.referencingEntity);
          if(isAffiliationSubgrid && isRequested)
          {
            const fetchMultilingualFields:boolean = this.authService.user.securityRoles.some(a=> a.name == 'iO OneKey User' || a.name == 'iO OneKey Admin');
            let { fetchXML } = this._getAccountsLinkedEntityFetchXML(linkEntity, accountId, null, null, formType,fetchMultilingualFields,fetchGlobalSearchAccountDetails);
            let linkEntityResponse: any[]
            let pagingInfo: any = null;
            let rawAllData = [];
            do {
              try {
                let response = await this.dynamics.executeFetchXml(
                  this._getLinkedEntityCollectionName(linkEntity),
                  fetchXML,
                  undefined,
                  pagingInfo?.nextPage ?? 0,
                  pagingInfo?.cookie ?? null,
                );
          
                if (response) {
                  pagingInfo = response.PagingInfo ?? null;
                  
                  if (Array.isArray(response.value)) {
                    rawAllData.push(...response.value);
                  }
                }
          
              } catch (error) {
                console.log("Error retreiving linked entity data: ", error);
                pagingInfo = null;
                rawAllData = null;
              }
            } while (pagingInfo !== null);
          
            // mapping responses
            linkEntityResponse = rawAllData;         
            let dbKey: string = '';
            if (linkEntity.subgrid.referencingEntity === ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY) {
              dbKey = linkEntity.subgrid.relationshipName;
            } else {
              dbKey = linkEntity.subgrid.referencingEntity;
            }
            if (dbKey) {
              // Same null-spread guard as _fetchGlobalSearchedAccountDetailsById above.
              linkEntities[DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + dbKey] = Array.isArray(linkEntityResponse) ? [...linkEntityResponse] : [];
            }
          }
        }
      }     
      const linkEntityAccountTo = linkEntities["account_linked_entityindskr_account_accountaccountaffiliation_affiliatedtoaccountid"]? linkEntities["account_linked_entityindskr_account_accountaccountaffiliation_affiliatedtoaccountid"]:[];
      const linkEntityAccountFrom = linkEntities["account_linked_entityindskr_account_accountaccountaffiliation_affiliatedfromaccountid"]? linkEntities["account_linked_entityindskr_account_accountaccountaffiliation_affiliatedfromaccountid"]:[];
      const brandAffiliationByAccountId = linkEntities["account_linked_entityindskr_accountbrandaffiliation"]? linkEntities["account_linked_entityindskr_accountbrandaffiliation"]:[];
      const linkedAccountContact = linkEntities["account_linked_entityindskr_accountcontactaffiliation"]? linkEntities["account_linked_entityindskr_accountcontactaffiliation"]:[];  
      return { linkEntityAccountTo, linkEntityAccountFrom, brandAffiliationByAccountId, linkedAccountContact };
    }

    private _getAccountsDefaultLinkEntityFetchXML(linkEntity, positionFilter, hourDifference,accountid = null) {
      let fetchXML = linkEntity.fetchXML;
          fetchXML = fetchXML.replace('{PositionFilterPH}', positionFilter);

          //modifiedon filter
          if(hourDifference) {
            let modifiedOnFilter = `<condition attribute="modifiedon" operator="last-x-hours" value="`+hourDifference+`" />`;
            // A new/edited note does not bump the account's modifiedon, so match on the note's own too.
            if(linkEntity.entityName == 'annotation') {
              modifiedOnFilter = `<filter type="or">` + modifiedOnFilter
                + `<condition attribute="modifiedon" operator="last-x-hours" value="`+hourDifference+`" entityname="annotation" /></filter>`;
            }
            let lastModifiedFilter = `
                <filter type="and">
                    ` + modifiedOnFilter + `
                </filter>`;
            if(accountid) {
              lastModifiedFilter = `
                <filter type="and">
                    ` + modifiedOnFilter + `
                    <filter type="and"><condition attribute="accountid" operator="eq" value="` + accountid + `" /></filter>
                </filter>`;
            }
            fetchXML = fetchXML.replace('{DeltaSyncFilter}', lastModifiedFilter);
          }
          else {
            let accountidfilter = '';
            if(accountid) {
              accountidfilter = `<filter type="and"><condition attribute="accountid" operator="eq" value="` + accountid + `" /></filter>`
            }
            fetchXML = fetchXML.replace('{DeltaSyncFilter}', accountidfilter);
          }
          fetchXML = fetchXML.replace(/\s+/g, ' ');
          return fetchXML;
    }
    async fetchAccountsDefaultLinkEntityData(positionFilter, hourDifference, linkedEntityFromForm:any[], accountid, loadFromDB){
      return Promise.all(FETCH_ACCOUNT_DEFAULT_LINK_ENTITES.map(async (linkEntity)=>{
        if(!linkEntity.isFetch || linkedEntityFromForm.find(l=> l.subgrid.referencingEntity == linkEntity.entityName)) return;
        let fetchXML = this._getAccountsDefaultLinkEntityFetchXML(linkEntity, positionFilter, hourDifference,accountid);

        if(loadFromDB){
        }else{
          await this.dynamics.executeFetchQuery("accounts", fetchXML).then( async (res) => {
              let dataToSave = res.map(rawRes => omitBy(rawRes, (value, key) => key.endsWith('@OData.Community.Display.V1.AttributeName')
                || key.endsWith('@Microsoft.Dynamics.CRM.lookuplogicalname')
                || key.endsWith('_LogicalName')
                ));
              if ((hourDifference || accountid) && Array.isArray(res)) {
                  // Try to retrieve from chunks first, then fall back to regular retrieve
                  let localRaw = await this.disk.retrieveFromChunks(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + linkEntity.entityName);
                  if (!localRaw) {
                    // Fall back to old non-chunked format
                    let temp = await this.disk.retrieve(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY+linkEntity.entityName);
                    if (temp && temp.raw) {
                      localRaw = temp.raw;
                    }
                  }
                  let leIdAttrName = linkEntity.entityName + "." + linkEntity.entityName + "id";
                  if (localRaw) {
                    res.forEach(rawRes => {
                      if (rawRes && rawRes.hasOwnProperty('accountid') && rawRes.hasOwnProperty(leIdAttrName)) {
                        let idx = localRaw.findIndex(a => a && a.hasOwnProperty('accountid') && a[leIdAttrName] == rawRes[leIdAttrName]);
                        if(this.accountOfflineService.selected && this.accountOfflineService.selected.id == rawRes.accountid && !this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag){
                          if(idx >= 0){
                            this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag = JSON.stringify(localRaw[idx]) != JSON.stringify(rawRes);
                          }else{
                            this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag = true;
                          }
                        }
                        if (idx >= 0) {
                            if (rawRes['statecode'] == 1 && rawRes['statuscode'] == 2) {
                                localRaw.splice(idx, 1);
                            } else {
                                localRaw[idx] = rawRes;
                            }
                        } else {
                            if (rawRes['statuscode'] != 2) {
                                localRaw.push(rawRes);
                            }
                        }
                      }
                    });
                  dataToSave = localRaw;
                }
                if(hourDifference && linkEntity.entityName == "annotation") {
                  let deletedRes = await this.fetchDeletedFromTrackChange(linkEntity.entityName, hourDifference);
                  if(deletedRes && Array.isArray(deletedRes)) {
                    deletedRes.forEach(dRes => {
                      if (dRes) {
                        let idx = dataToSave.findIndex(a => a && a.hasOwnProperty('accountid') && a[leIdAttrName] == dRes["indskr_entityid"]);
                        if (idx >= 0) {
                          if(this.accountOfflineService.selected && this.accountOfflineService.selected.id == dataToSave[idx].accountid){
                            this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag = true;
                          }
                          dataToSave.splice(idx, 1);
                        }
                      }
                    });
                  }
                }
              }
              
              // Use worker to batch and save data to prevent app crashes with large datasets
              if (Array.isArray(dataToSave) && dataToSave.length > 0) {
                this._postMessageOnLinkedEntityWorker(linkEntity.entityName, dataToSave, DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY);
              }
            },
            (err) => {
              console.log(err);
            })
        }
      }))
    }

    private mapLinkEntityToSearch(linkEntity, searchCategory, linkEntityData) {

        if (searchCategory) {
            this._postMessageOnAdvancedSearchWorker({ type: 'mapLinkEntitySearchIndex', rawList: linkEntityData, configIndex: searchCategory });
        }
        if(linkEntity.subgrid.referencingEntity == 'indskr_indskr_customeraddress_v2'){
            this.searchConfigService.contactConfiguredFormDefaultConfigs.forEach(defaultConfig=>{
                let currentConfig:searchIndexDataModel;
                let idx = this.searchConfigService.accountConfiguredSearchIndexConfig.findIndex(conf=> conf.categoryRelativePath == defaultConfig.categoryRelativePath);
                if(idx >= 0){
                    currentConfig = this.searchConfigService.accountConfiguredSearchIndexConfig[idx];
                }else{
                    const clonedDefaultConfig: searchIndexDataModel = JSON.parse(JSON.stringify(defaultConfig));
                    if(clonedDefaultConfig.translationKey) {
                      clonedDefaultConfig.categoryDisplayName = this.translate.instant(clonedDefaultConfig.translationKey);
                    }
                    else {
                      clonedDefaultConfig.categoryDisplayName = clonedDefaultConfig.categoryName;
                    }

                    // Custom assignment for Address
                    clonedDefaultConfig.fromAttribute = 'indskr_addressid';
                    clonedDefaultConfig.toAttribute = 'indskr_address';

                    currentConfig = clonedDefaultConfig;
                    this.searchConfigService.accountConfiguredSearchIndexConfig.push(currentConfig);
                }
                this._postMessageOnAdvancedSearchWorker({ type: 'mapLinkEntitySearchIndex', rawList: linkEntityData, configIndex: currentConfig });
            });
        }
    }

    private _initAdvancedSearchServiceWorker() {
        this._advancedSearchConfigServiceWorker = new Worker('./assets/workers/advanced-search-worker.js');
        this._advancedSearchConfigServiceWorker.onmessage = (event) => {
            this.ngZone.run(() => {
                let index = this.searchConfigService.accountConfiguredSearchIndexConfig.findIndex(o => o.categoryRelativePath == event.data.categoryRelativePath);
                if (index > -1) {
                    this.searchConfigService.accountConfiguredSearchIndexConfig[index] = event.data
                }
                else this.searchConfigService.accountConfiguredSearchIndexConfig.push(event.data);
            })
        };
    }

    private _postMessageOnAdvancedSearchWorker(data){
        this._advancedSearchConfigServiceWorker.postMessage(data);
    }

    /**
     * Initializes the data partition worker for bucketing account data
     * Similar to contacts, accounts need to be partitioned into buckets for efficient storage
     */
    private _initDataPartitionWorker() {
      this._dataPartitionWorker = new Worker('./assets/workers/data-partitioner-worker.js');
      
      this._dataPartitionWorker.onmessage = async (event) => {
        try {
          await this._replaceAccountBuckets(event.data);
        } catch (error) {
          console.error('_replaceAccountBuckets: ', error);
        } finally {
          this._finishAccountsSave();
        }
      };

      this._dataPartitionWorker.onerror = () => this._finishAccountsSave();
    }

    // Readers wait while busy, so busy must clear on every outcome or account sync hangs.
    private _finishAccountsSave() {
      this._isDataPartitionWorkerBusy = false;
      const queued = this._queuedPartitionPayload;
      this._queuedPartitionPayload = null;
      this._onAccountsSaved();
      if (queued) this._postMessageOnDataPartitioner(queued);
    }

    // Overwrite buckets before removing leftovers: a delete-all first leaves readers a partial list that they then save (OMNI-62878).
    private async _replaceAccountBuckets(buckets: Record<string, any[]>): Promise<void> {
      const index: any = await this.disk.batchFetch({ ...DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_ACCOUNTS, include_docs: false }, false, true);
      const existingIds: string[] = (index?.rows ?? []).filter(row => row?.id && !row.value?.deleted).map(row => row.id);
      await this.disk.saveDataToDynamics(buckets);
      for (const id of existingIds.filter(id => !(id in buckets))) {
        await this.disk.remove(id);
      }
    }

    /**
     * Posts message to data partition worker to bucket account data
     */
    private _postMessageOnDataPartitioner(data) {
      // Keep only the newest full list while a save is in flight; dropping it would leave disk behind memory.
      if (this._isDataPartitionWorkerBusy) {
        this._queuedPartitionPayload = data;
        return;
      }
      this._isDataPartitionWorkerBusy = true;
      this._accountsSaved = new Promise<void>(resolve => this._onAccountsSaved = resolve);
      try {
        this._dataPartitionWorker.postMessage(data);
      } catch (error) {
        this._finishAccountsSave();
        throw error;
      }
    }

    /**
     * Initializes the linked entity worker for account linked entities
     * Handles batch processing of linked entities like addresses, affiliations, etc.
     */
    private _initLinkedEntityWorker() {
      this._linkedEntityWorker = new Worker('./assets/workers/linked-entity-worker.js');
      
      this._linkedEntityWorker.onmessage = async (event) => {
        const startTime = performance.now();
        try {
          this._isLinkedEntityWorkerBusy = false; // Mark worker as available
          
          const { entityName, batches, totalRecords, totalBatches, processingTime } = event.data;
          
          if (batches && batches.length > 0) {
            // Get the dbKeyPrefix from the queue item (it should be the first item that was processed)
            const dbKeyPrefix = event.data.dbKeyPrefix || DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY;
            // Save batches
            await this._saveLinkedEntityBatches(entityName, batches, dbKeyPrefix);
          }
          
          const endTime = performance.now();
          const totalTime = (endTime - startTime).toFixed(2);
          const workerTime = parseFloat(processingTime) || 0;
          const saveTime = (parseFloat(totalTime) - workerTime).toFixed(2);
          
          // Process next item in queue if any
          this._processLinkedEntityQueue();
          
        } catch (e) {
          this._isLinkedEntityWorkerBusy = false;
          // Process next item in queue even on error
          this._processLinkedEntityQueue();
        }
      };

      this._linkedEntityWorker.onerror = (error) => {
        this._isLinkedEntityWorkerBusy = false;
        this._processLinkedEntityQueue();
      };
    }

    /**
     * Posts message to linked entity worker to batch data
     * Uses a queue system to handle multiple concurrent requests
     */
    private _postMessageOnLinkedEntityWorker(entityName: string, data: any[], dbKeyPrefix: string = DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY) {
      const timestamp = new Date().toISOString();
      
      // Add to queue
      this._linkedEntityWorkerQueue.push({ entityName, data, dbKeyPrefix });
      
      // Process queue if worker is not busy
      if (!this._isLinkedEntityWorkerBusy) {
        this._processLinkedEntityQueue();
      } else {
      }
    }

    /**
     * Processes the linked entity worker queue
     */
    private _processLinkedEntityQueue() {
      const timestamp = new Date().toISOString();
      
      if (this._isLinkedEntityWorkerBusy) {
        return;
      }
      
      if (this._linkedEntityWorkerQueue.length === 0) {
        return;
      }

      const nextItem = this._linkedEntityWorkerQueue.shift();
      if (nextItem) {
        
        this._isLinkedEntityWorkerBusy = true;
        this._linkedEntityWorker.postMessage({
          type: 'batchLinkedEntityData',
          entityName: nextItem.entityName,
          dataList: nextItem.data,
          batchSize: 500,
          dbKeyPrefix: nextItem.dbKeyPrefix
        });
      }
    }

    /**
     * Saves linked entity batches for accounts
     * Supports chunked saving for very large datasets
     */
    private async _saveLinkedEntityBatches(entityName: string, batches: any[], dbKeyPrefix: string = DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY) {
      const startTime = performance.now();
      const timestamp = new Date().toISOString();
      
      
      let successCount = 0;
      let failedCount = 0;
      let allData = [];

      // Collect all data from batches
      for (const batch of batches) {
        allData = allData.concat(batch.data);
      }

      const dbKey = dbKeyPrefix + entityName;

      // Save all data at once
      try {
        const saveStartTime = performance.now();
        // Check if we need chunked saving (for very large datasets)
        const CHUNK_SIZE_THRESHOLD_ITEMS = 5000;
        // saveLinkedEntityData picks chunked or single-document storage and clears the other,
        // so a key that grows past the threshold (or shrinks back under it) never leaves a
        // stale copy in the shape some readers happen to check first.
        await this.disk.saveLinkedEntityData(dbKey, allData, CHUNK_SIZE_THRESHOLD_ITEMS);
        successCount = allData.length;
        const saveEndTime = performance.now();
        const saveTime = (saveEndTime - saveStartTime).toFixed(2);
        
      } catch (error) {
        failedCount = allData.length;
      }

      const endTime = performance.now();
      const totalTime = (endTime - startTime).toFixed(2);
    }

  public async getAccountTimelineInfo(account: Account, page?: number, size?: number) {
    // TODO * need this is account timeline
    this.accountOfflineService.isAccountTimelineLoaded = false;
    await Promise.all([
      this.getAccountTimelineActivities(account, page, size),
      this.getAccountTimelineEvent(account, size, page),
      this.getAccountTimelineSurvey(account, size, page)
    ])
    this.accountOfflineService.isAccountTimelineLoaded = true;
  }

  public async getAccountTimelineInfoPaginated(account: Account, page: number = 1, size: number = 3) {
    return Promise.allSettled([
      this.getCasesTimeline(account.id, page, size),
      this.getEmailsTimeline(account.id, page, size),
      this.getMeetingTimeline(account, page, size),
      this.getPhonecallTimeline(account.id, page, size),
      // Before the procedure orders: when both list an order, the timeline keeps the first.
      this.getSalesOrderTimeline(account.id, page, size),
      this.getOrderTimeline(account.id, page, size),
      this.getAccountTimelineEvent(account, size, page),
      this.getAccountTimelineSurvey(account, size, page)
    ])
  }

  async getCasesTimeline(accountId: string, page: number = 1, size: number = 3) {
    if (!this.authService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE)) return [];
    const activities = [];
    const fetchXml = this.formatTimelineFetchXml(ACCOUNT_TIMELINE_FETCH_QUERIES.fetchCasesForAccount, accountId, page, size);
    try {
      const cases = await this.dynamics.executeFetchQueryWithPageNumber('incidents', fetchXml, page);
      const custome360FA = this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI, true);
      cases.forEach(o => {
        let activity = new Activity(o);
        o['expertCategory'] = o['_indskr_expertcategorytype_value'];
        o['expertCategoryName'] = o['indskr_expertcategorytype_value@OData.Community.Display.V1.FormattedValue'] = o['_indskr_expertcategorytype_value@OData.Community.Display.V1.FormattedValue'];
        o['ownerid_value@OData.Community.Display.V1.FormattedValue'] = o['indskr_ownerfullname'];
        o['productid_value@OData.Community.Display.V1.FormattedValue'] = o['_productid_value@OData.Community.Display.V1.FormattedValue'];
        o['productid_value'] = o['_productid_value'];
        o['indskr_omnipresencestage_value@OData.Community.Display.V1.FormattedValue'] = o['_indskr_omnipresencestage_value@OData.Community.Display.V1.FormattedValue'];
        if (custome360FA) {
          if (o['expertCategory'] && o['expertCategoryName']) {
            o['indskr_expertcategory_value'] = o['expertCategory'];
            o['indskr_expertcategory'] = {
              id: o['expertCategory'],
              name: o['expertCategoryName'],
            }
          }
          activity = new CaseActivity(o);
        }
        activities.push(activity);
      });
    } catch (e) {
      console.error("Failed to fetch cases for timeline: ", e, " \nfetchXml: ", fetchXml);
    }
    return activities;
  }

  async getEmailsTimeline(accountId: string, page: number = 1, size: number = 3) {
    if (!this.authService.hasFeatureAction(FeatureActionsMap.EMAIL_ACTIVITY)) return [];
    const activities = [];
    const custome360FA = this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI, true);
    const fetchXml = this.formatTimelineFetchXml(ACCOUNT_TIMELINE_FETCH_QUERIES.fetchEmailsForAccount, accountId, page, size);
    try {
      const emails = await this.dynamics.executeFetchQueryWithPageNumber('emails', fetchXml, page);
      const groupedEmails = groupBy(emails, 'activityid');
      // Process each group to create consolidated appointment
      Object.keys(groupedEmails).forEach(activityId => {
        const emailGroup = groupedEmails[activityId];
        if (emailGroup.length === 0) return;
        emailGroup['0']['indskr_channel'] = emailGroup[0]['_indskr_channel_value'];
        emailGroup['0']['channelName'] = emailGroup['0']['_indskr_channel_value@OData.Community.Display.V1.FormattedValue'];
        // Use the first email as the base email
        const baseEmail: EmailActivity = new EmailActivity(emailGroup[0]);
        if (custome360FA) {
          // Initialize arrays for linked entities
          const parties = [];
          const attachments = [];
          emailGroup.forEach((email) => {
            if (email.hasOwnProperty('email_activity_parties')) {
              email['emailActivityParties'] = [];
              email['email_activity_parties'].filter(party => party['participationtypemask'] == 2).forEach(party => {
                const emailParty = {
                  'indskr_contactid': party['_partyid_value'],
                  'contact_firstname': party['_partyid_value@OData.Community.Display.V1.FormattedValue']
                }
                if (party['addressused']) {
                  emailParty['emailAddresses'] = [{
                    'emailAddress': party['addressused'],
                    'email_statuscode': email['statuscode'],
                    'readOn': email['readOn']
                  }];
                }
                if (!parties.some(party => party.indskr_contactid === emailParty.indskr_contactid)) {
                  parties.push(emailParty);
                }
              });
            }

            if (email['attachments.indskr_emailattachmentid']) {
              const attachment = {
                indskr_emailattachmentid: email['attachments.indskr_emailattachmentid'],
                indskr_resourceid: email['indskr_ioresourceid'] ?? email['indskr_documentid'],
                indskr_ckmtitle: email['attachments.indskr_ckmtitle'],
                indskr_ckmthumbnailurl: email['attachments.indskr_ckmthumbnailurl'],
                indskr_ckmasseturl: email['attachmentsindskr_ckmasseturl']
              };
              if (!attachments.some(list => list.indskr_emailattachmentid === attachment.indskr_emailattachmentid)) {
                attachments.push(attachment);
              }
            }
          });
          baseEmail.emailActivityParties = parties;
          baseEmail.emailAttachments = attachments;
          //To update parties status
          const mail = new EmailActivity(baseEmail);
          baseEmail.emailActivityParties = mail.emailActivityParties;
          baseEmail.status = mail.status;
        }
        activities.push(baseEmail);
      });
    } catch (e) {
      console.error("Failed to fetch emails for timeline: ", e, " \nfetchXml: ", fetchXml);
    }
    return activities;
  }

  async getMeetingTimeline(account: Account, page: number = 1, size: number = 3) {
    const fetchXml = this.formatTimelineFetchXml(ACCOUNT_TIMELINE_FETCH_QUERIES.fetchMeetingsForAccount, account.id, page, size * 10);
    const activities = [];
    try {
      const meetings = await this.dynamics.executeFetchQueryWithPageNumber('appointments', fetchXml, page);
      const custome360FA = this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI, true);
      
      activities.push(...this.formatMeetingsResponse(meetings, custome360FA, account));
      
     
    } catch (e) {
      console.error("Failed to fetch meetings for timeline: ", e, " \nfetchXml: ", fetchXml);
    }
    return activities;
  }

  /**
   * Formats the flat meetings response into consolidated appointments with unique linked entities
   * @param meetings - Flat array of meeting records from Dynamics
   * @returns Array of consolidated appointment objects
   */
  private formatMeetingsResponse(meetings: any[], custome360FA: boolean, account: Account): AppointmentActivity[] {
    if (!meetings || meetings.length === 0) {
      return [];
    }

    // Group meetings by activityid
    const groupedMeetings = groupBy(meetings, 'activityid');
    const appointments: AppointmentActivity[] = [];

    // Process each group to create consolidated appointment
    Object.keys(groupedMeetings).forEach(activityId => {
      const meetingGroup = groupedMeetings[activityId];
      if (meetingGroup.length === 0) return;

      // Use the first meeting as the base appointment
      const baseAppointment: AppointmentActivity = new AppointmentActivity(meetingGroup[0]);
      if (custome360FA) {
        // Initialize arrays for linked entities
        const activityAccounts: Account[] = [];
        const playlist: Array<Presentation | Resource> = [];
        const activityProducts: Brand[] = [];
        const covisitors: AccompainedUser[] = [];

        // Process each meeting in the group to extract linked entities
        meetingGroup.forEach((meeting) => {
          // Extract activity accounts
          if (meeting['account.indskr_accountid']) {
            const obj: any = {
              id: meeting['account.indskr_accountid'],
              accountName: meeting['account.indskr_accountid@OData.Community.Display.V1.FormattedValue']
            };
            if (!activityAccounts.some(list => list.id === obj.id))
              activityAccounts.push(obj as Account);
          }
          // Extract activity presentations
          if (meeting['presentationId']) {
            const obj: any = {
              contentId: meeting['presentationId'],
              name: meeting['presentationName'],
              thumbnailURL: meeting['pre_thumbnailUrl']
            };
            if (!playlist.some(list => list.contentId === obj.contentId))
              playlist.push(obj as Presentation);
          }

          // Extract activity resources
          if (meeting['resourceId']) {
            const obj: any = {
              contentId: meeting['resourceId'],
              name: meeting['resourceName'],
              thumbnailURL: meeting['res_thumbnailUrl']
            };
            if (!playlist.some(list => list.contentId === obj.contentId))
              playlist.push(obj as Resource);
          }

          // Extract activity products
          if (meeting['product.indskr_productid']) {
            const obj: any = {
              isSelected: true,
              name: meeting['product.indskr_productid@OData.Community.Display.V1.FormattedValue'],
              ID: meeting['product.indskr_productid']
            };
            if (!activityProducts.some(list => list.ID === obj.ID))
              activityProducts.push(obj as Brand);
          }

          // Extract activity co-visitors
          if (meeting['accompanieduser.indskr_user']) {
            const obj = {
              id: meeting['accompanieduser.indskr_user'],
              name: meeting['accompanieduser.indskr_user@OData.Community.Display.V1.FormattedValue']
            }
            if (!covisitors.some(list => list.id === obj.id))
              covisitors.push(obj as AccompainedUser)
          }
        });

        baseAppointment.accounts = activityAccounts;
        baseAppointment.presentations = playlist;
        baseAppointment.products = activityProducts;
        baseAppointment.accompaniedUserList = covisitors;
      }
      appointments.push(baseAppointment);
    });

    return appointments;
  }

  async getPhonecallTimeline(accountId: string, page: number = 1, size: number = 3) {
    if (!this.authService.hasFeatureAction(FeatureActionsMap.PHONECALL_ACTIVITY)) return [];
    const fetchXml = this.formatTimelineFetchXml(ACCOUNT_TIMELINE_FETCH_QUERIES.fetchPhonecallsForAccount, accountId, page, size);
    const activities = [];
    try {
      const phonecalls = await this.dynamics.executeFetchQueryWithPageNumber('phonecalls', fetchXml, page);
      const custome360FA = this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI, true);
      phonecalls.forEach(o => {
        let activity = new Activity(o);
        if (custome360FA) {
          activity = new PhoneActivity(o);
          //Customer 360 timiline fetch response mapping
          (activity as PhoneActivity).contacts = [];
          if (o['contactId']) {
            const obj: any = {
              ID: o.contactId,
              fullName: o['contactId@OData.Community.Display.V1.FormattedValue'],
            };
            (activity as PhoneActivity).contacts.push(obj);
          }
          (activity as PhoneActivity).products = [];

          if (o['product']) {
            const obj: any = {
              isSelected: true,
              name: o['product@OData.Community.Display.V1.FormattedValue'],
              ID: o.product
            };
            (activity as PhoneActivity).products.push(obj);
          }
          (activity as PhoneActivity).selectedMobileNumber = activity['phonecallphonenumber'] = o['phonenumber'];
        }
        const existingActivity = activities.find(ac => ac.ID === activity.ID);
        if (existingActivity) {
          //Since there can be multiple products, add only unique products
          existingActivity.products = uniqBy([...existingActivity.products, ...activity.products], 'ID');
        } else {
          activities.push(activity);
        }
      });
    } catch (e) {
      console.error("Failed to fetch phonecalls for timeline: ", e, " \nfetchXml: ", fetchXml);
    }
    return activities;
  }

  private processOrderForTimeline(rawOrder: any, activities: any[]): void {
    rawOrder['ownerid'] = rawOrder['_ownerid_value'];
    rawOrder['ownerName'] = rawOrder['_ownerid_value@OData.Community.Display.V1.FormattedValue'];
    
    if (rawOrder['order_details.productid']) {
      const obj: any = {
        isSelected: true,
        productName: rawOrder['order_details.productname'],
        productid: rawOrder['order_details.productid']
      };
      rawOrder['products'] = [obj];
    }

    let activity = null;
    if (rawOrder['indskr_ordertype'] && rawOrder['indskr_ordertype'] == 548910001) {
      activity = new SurgeryOrderActivity(rawOrder);
      activity.type = ActivityType.SurgeryOrder;
      if (activity.ownerId != this.authService.user.systemUserID) {
        activity.isTeamOrder = true;
      }
      if (activity.offlineDBId && activity.ownerId && activity.surgeryOrderStatusString == 'Completed') {
        this.addOrUpdateActivity(activities, activity);
      }
    } else if (rawOrder['indskr_ordertype'] && rawOrder['indskr_ordertype'] == 548910002) {
      activity = new ProcedureTrackerActivity(rawOrder);
      activity.type = ActivityType.ProcedureTracker;
      if (activity.ownerId != this.authService.user.systemUserID) {
        activity.isTeamOrder = true;
      }
      if (activity.status == 548910001) {
        this.addOrUpdateActivity(activities, activity);
      }
    } else {
      activity = new OrderActivity(rawOrder);
      activity.type = ActivityType.Order;
      if (activity.ownerId != this.authService.user.systemUserID) {
        activity.isTeamOrder = true;
      }
      if (activity.offlineDBId && activity.ownerId && (activity.orderStatusString == 'Approved' || activity.orderStatusString == 'Fulfilled')) {
        activity.statusString = activity.orderStatusString;
        this.addOrUpdateActivity(activities, activity);
      }
    }
  }

  private addOrUpdateActivity(activities: any[], activity: any): void {
    const existingActivity = activities.find(ac => ac.ID === activity.ID);
    if (existingActivity) {
      //Since there can be multiple products, add only unique products
      existingActivity.products = uniqBy([...existingActivity.products, ...activity.products], 'ID');
    } else {
      activities.push(activity);
    }
  }

  private async fetchOrdersWithTimeline(accountId: string, page: number, size: number, orderAttribute: string, orderTypeCondition: string): Promise<any[]> {
    const activities = [];
    let fetchXml = this.formatTimelineFetchXml(ACCOUNT_TIMELINE_FETCH_QUERIES.fetchOrdersForAccount, accountId, page, size);
    
    try {
      fetchXml = fetchXml.replace('{{orderAttribute}}', orderAttribute).replace('{{orderType}}', orderTypeCondition);
      const orders = await this.dynamics.executeFetchQueryWithPageNumber('salesorders', fetchXml, page);
      
      orders.forEach(rawOrder => {
        this.processOrderForTimeline(rawOrder, activities);
      });
    } catch (e) {
      console.error("Failed to fetch orders for timeline: ", e, " \nfetchXml: ", fetchXml);
    }
    
    return activities;
  }

  async getOrderTimeline(accountId: string, page: number = 1, size: number = 3) {
    if ((!this.authService.hasFeatureAction(FeatureActionsMap.ORDER_MANAGEMENT)
      && !this.authService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_ORDERS))
      || (!this.authService.user.hasProcedureLog)
      || (!this.authService.user.hasBulkProcedureLog)) return [];
    
    const orderAttribute = '<order attribute="indskr_scheduleddate" descending="true" />';
    const orderTypeCondition = '<condition attribute="indskr_ordertype" operator="in"><value>548910001</value><value>548910002</value></condition>';
    
    return await this.fetchOrdersWithTimeline(accountId, page, size, orderAttribute, orderTypeCondition);
  }

  async getSalesOrderTimeline(accountId: string, page: number = 1, size: number = 3) {
    // The new order flow's orders replace the legacy ones.
    if (this.authService.hasFeatureAction(FeatureActionsMap.NEW_ORDER_FLOW))
      return this.getOrderCaptureTimeline(accountId, page, size);
    if ((!this.authService.hasFeatureAction(FeatureActionsMap.ORDER_MANAGEMENT)
      && !this.authService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_ORDERS))) return [];
    
    const orderAttribute = '<order attribute="createdon" descending="true" />';
    const orderTypeCondition = '<condition attribute="indskr_ordertype" operator="eq" value="548910000" />';
    
    return await this.fetchOrdersWithTimeline(accountId, page, size, orderAttribute, orderTypeCondition);
  }

  /** The account's orders, as the order screen's History lists them, last changed first. */
  async getOrderCaptureTimeline(accountId: string, page: number = 1, size: number = 3): Promise<OrderCaptureActivity[]> {
    const fetchXml = this.formatTimelineFetchXml(ACCOUNT_TIMELINE_FETCH_QUERIES.fetchOrderCaptureForAccount, accountId, page, size);
    try {
      const orders = await this.dynamics.executeFetchQueryWithPageNumber('salesorders', fetchXml, page);
      return (orders ?? []).map(order => new OrderCaptureActivity(order)).filter(order => !!order.ID);
    } catch (e) {
      console.error("Failed to fetch orders for timeline: ", e, " \nfetchXml: ", fetchXml);
      return [];
    }
  }

  formatTimelineFetchXml(fetchXml, accountId, page, size) {
    const countAttribute = size > 0 ? `count="${size}"` : '';
    let ownerPlaceHolder = '';
    let businessUnitPlaceholder = '';
    if (this.authService.user.timelineActivites) {
      const timelineActivities = this.authService.user.timelineActivites ?? 451680002;
      if (timelineActivities === 451680001) {
        //BusinessUnit
        businessUnitPlaceholder = "<filter type=\"and\"><condition attribute=\"businessunitid\" operator=\"eq\" value=\"" + this.authService.user.xBusinessUnitId + "\" /></filter>";
      } else if (timelineActivities === 451680000) {
        //Individual
        ownerPlaceHolder = "<condition attribute=\"ownerid\" operator=\"eq-userid\"/>";
      }
      //Default: Organisation
    }
    fetchXml = fetchXml.replace('{{count}}', countAttribute).replace('{{page}}', 'page="' + page.toString() + '"').replace("{{accountId}}", accountId);
    fetchXml = fetchXml.replace('{{owneridPlaceholder}}', ownerPlaceHolder).replace('{{businessUnitPlaceholder}}', businessUnitPlaceholder);
    return fetchXml;
  }

  async getAccountTimelineActivities(account: Account, page?:number, size?:number) {
    
    let url: string = this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.accounts.GET_ACCOUNT_TIMELINEINFO.replace('{{AccountId}}', account.id);
    url = url.replace('{{businessUnitId}}', this.authService.user.xBusinessUnitId);
    let timelineActivities: number = 451680002; // Organisation
    if(this.authService.user.timelineActivites) {
      timelineActivities = this.authService.user.timelineActivites;
    }
    url = url.replace('{{timelineActivities}}', timelineActivities.toString());

    if (page && size) {
      url = url + `&page=${page}&size=${size}`;
    }

    let response: any;
    try {
      response = await this.http.get(url).toPromise();
    } catch (error) {
      console.error('getAccountTimelineInfo: ', error);
    }
    if (response) {
      return this.accountOfflineService.mapActivitesByAccount(response)
    }
  }

  public async getAccountTimelineEvent(account: Account, size?: number, pageNumber?: number) {
    try {
      if (!this.authService.hasFeatureAction(FeatureActionsMap.EVENT_TOOL)) {
        account.mapEvents([]); return []; 
      } else {
        // TODO * we might need to pass record size here

        let fetchXml = ACCOUNT_EVENT_FETCH_QUERIES.fetchEventsForAccount.replace("{accountid}", account.id);
        if (size) {
          const countAttribute = size > 0 ? `count="${size}"` : '';
          fetchXml = fetchXml.replace('{countattribute}', countAttribute);
        } else {
          fetchXml = fetchXml.replace('{countattribute}', '');
        }
        const accountEventDetailsResponse: EventActivity[] = await this.dynamics.executeFetchQueryWithPageNumber('msevtmgt_events', fetchXml, pageNumber);
        account.mapEvents(accountEventDetailsResponse);
        const response = [];
          if (accountEventDetailsResponse && Array.isArray(accountEventDetailsResponse)) {
            accountEventDetailsResponse.forEach((event: EventActivity) => {
              const ev = new EventActivity(event)
              ev.type = ActivityType.Event;
              ev['scheduledStart'] = ev.startDate;
              response.push(ev);

            })
          return response
        }
      }
    }
    catch {
      console.log("Invaild Timeline Events data");
    }
    return [];
  }

  public async getAccountTimelineSurvey(account: Account, size?: number, pageNumber?: number) {
    if (this.authService.hasFeatureAction(FeatureActionsMap.ACCOUNT_SURVEY)) {
      return await this.customerAssessService.getSurveysForTimeline(account.id, SurveyCategory.ACCOUNT, size, pageNumber);
    }
  }

    public async getRawAccountDetailsById(id:string){
        const accountsFromDB = await this._getAccountsFromDB();
        if (Array.isArray(accountsFromDB)) {
            const foundAccount = accountsFromDB.find(savedAccount => savedAccount && savedAccount.accountid === id);
            if (foundAccount) {
                return foundAccount;
            }
        }
    }

    public async getRealTimeAccountDetailsOnline(id:string, fetchDataOnly = false,forceFullSync = true){
        let url:string = this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.accounts.GET_ACCOUNT_ID.replace('{{AccountId}}',id);
        let response: any;
        try {
            this.accountOfflineService.refreshUIofCurrentSelectedAccountFlag = false;
            if (!fetchDataOnly) {
              let syncState = await this.disk.getSyncState(DB_SYNC_STATE_KEYS.SYNC_ACCOUNT);
              response = await this._doAccountsConfiguredDisplaySync(null,null,forceFullSync,false,syncState.lastUpdatedTime,id);
              if(Array.isArray(response)){
                response = response [0];
              }
            } else {
              response = await this._fetchGlobalSearchedAccountDetailsById(id);
            }

            return response;
        } catch (error) {
            console.error('getAccountInfo: ', error);
        }
    }

    public async createUpdateAccountOnline(payload):Promise<any> {
        let url:string = this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.accounts.CREATE_ACCOUNT;
        // Create new account on dynamics and return promise with success or failure
        return this.http.post(url, payload).toPromise();
    }
        /**
    * get interaction date for account http call to get intaraction dates for all account
    * @param forceFullSync
    */
    private async syncInteractionDataForAccount(doFullSyn: boolean, lastUpdatedTime): Promise<any> {
        let url = this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.accounts.GET_ACCOUNT_INTERACTION;
        const startDateFrom = this.authService.getFromToDateRangeInUTCMiliSec(undefined, undefined).from;
        url = url.replace('{{positionIDs}}', this.authService.getLoggedInUserPositions().toString());
        url = url.replace('{startDate}', startDateFrom);
        url = (doFullSyn) ? url : url + '&lastUpdatedTime=' + lastUpdatedTime;
        const accountInteractionSyncInfo: EntitySyncInfo = {
            entityName: EntityNames.accountInteraction,
            totalFailed: 0,
            totalSynced: 0,
            errors: [],
            syncStatus: true
        };
        let response: any;
        try {
            response = await this.http.get(url, Endpoints.GLOBAL_SYNC_HEADER).pipe(timeout(25000)).toPromise();
        } catch (error) {
            console.error('syncAccountInteraction: ', error);
            this.deltaService.addSyncErrorToEntitySyncInfo(accountInteractionSyncInfo, url, error);
            response = [];
        }
        return response;
    }

    private filterByApprovalStatus(searchResults: any[]): any[] {
      if (!searchResults) return [];
      let filtered = [];

      try {
        // Filter already approved ones
        const approvedIds: Map<string, any> = new Map();
        for (const result of searchResults) {
          if (
            result['position.positionid']
            && result['cp.indskr_approvalstatus'] === 548910002
            && result.accountid
          ) {
            approvedIds.set(result.accountId, true);
          }
        }
        filtered = approvedIds.size > 0
          ? searchResults.filter(r => approvedIds.has(r.accountid))
          : searchResults;
        filtered = uniqBy(filtered, 'accountid');
      } catch (error) {
        console.error('filterByApprovalStatus: ', error);
      }

      return filtered;
    }

    /**
     * add interaction date and type to contacts raw
     * @param conatctsResponse All contacts raw data
     * @param interactionResponse  All interaction contact raw data
     */
    private async mapAccountWithInteraction(accountResponse: any, interactionResponse: any): Promise<void> {
        try {
            if (Array.isArray(accountResponse) && Array.isArray(interactionResponse) && interactionResponse.length > 0 && accountResponse.length > 0) {
                for (let i = 0; i < accountResponse.length; i++) {
                    const rawAccount = accountResponse[i];
                    const foundIndex = interactionResponse.findIndex(a => a.accountId === rawAccount.accountid);
                    if (foundIndex >= 0) {
                        let interaction = interactionResponse[foundIndex];
                        rawAccount['interactionDate'] = interaction['interactionDate'];
                        rawAccount['interactionType'] = interaction['interactionType'];
                    }
                }
            }
        } catch (error) {
            console.error('In mapAccountWithInteraction : ', error)
        }
    }

    async globalSearch(selectedSuggestions: SelectedSuggestionPillDataModel[], pageNumber: number = 0, pageSize: number = 50, pageCookie: string = null): Promise<any> {
      let finalSearchResult: any[] = [];
      let pagingInfo = null;
      let hasMoreRecords = false;

      if (Array.isArray(selectedSuggestions)) {
        let nonAggregatedCategorySuggestions: SelectedSuggestionPillDataModel[] = [];
        let aggregatedCategorySuggestions: SelectedSuggestionPillDataModel[] = [];

        // Split aggregated & non-aggregated categories
        for (let i = 0; i < selectedSuggestions.length; i++) {
          const suggestion = selectedSuggestions[i];
          if (suggestion.isAggregatedSection) {
            aggregatedCategorySuggestions.push(suggestion);
          } else {
            nonAggregatedCategorySuggestions.push(suggestion);
          }
        }

        const shouldFilterByApprovalStatus = this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_VISIBILITY_APPROVAL_BASED);

        // Non-aggregated
        const fetchXML = this.accountOfflineService.createGlobalSearchFetchXML(nonAggregatedCategorySuggestions);
        const response = await this.runGlobalSearchTask(fetchXML, pageNumber, pageSize, pageCookie);

        if (response) {
          if (response.hasOwnProperty(DynamicsConstant.hasMoreRecords)) {
            hasMoreRecords = response[DynamicsConstant.hasMoreRecords];
          }
          pagingInfo = response.PagingInfo;
          }

        let nonAggregatedCategorySearchResult = response?.value;

        if (shouldFilterByApprovalStatus) {
          nonAggregatedCategorySearchResult = this.filterByApprovalStatus(nonAggregatedCategorySearchResult);
        }

        if (nonAggregatedCategorySuggestions.length > 0 && aggregatedCategorySuggestions.length === 0) {
          // Only need non aggregated search result
          finalSearchResult = [
            ...nonAggregatedCategorySearchResult ?? []
          ]
        } else {
          // Aggregated category search
          let aggregatedCategorySearchResult;
          for (let i = 0; i < aggregatedCategorySuggestions.length; i++) {
            const selectedSuggestion = aggregatedCategorySuggestions[i];
            const splitSuggestions = getSearchSuggestionsData(selectedSuggestion);

            let categorySearchResult: AccountGlobalSearchDTO[] = [];
            for (let j = 0; j < splitSuggestions.length; j++) {
              const suggestion = splitSuggestions[j];
              const fetchXML = this.accountOfflineService.createGlobalSearchFetchXML([suggestion]);
              const response = await this.runGlobalSearchTask(fetchXML, pageNumber, pageSize, pageCookie);
              
              if (response) {
                if (response.hasOwnProperty(DynamicsConstant.hasMoreRecords)) {
                  hasMoreRecords = response[DynamicsConstant.hasMoreRecords];
                }
                pagingInfo = response.PagingInfo;
              }
              let searchResult = response?.value;

              if (shouldFilterByApprovalStatus) {
                searchResult = this.filterByApprovalStatus(searchResult);
              }
              // xor each partial search result
              categorySearchResult = xorBy(categorySearchResult, searchResult, 'accountid');
            }

            // AND each non-aggregated category search result
            if (categorySearchResult.length > 0) {
              if (!aggregatedCategorySearchResult) {
                aggregatedCategorySearchResult = [
                  ...categorySearchResult
                ];
              } else {
                aggregatedCategorySearchResult = intersectionBy(finalSearchResult, categorySearchResult, 'accountid');
              }
            } else {
              aggregatedCategorySearchResult = [];
              break;
            }
          }

          if (nonAggregatedCategorySuggestions.length === 0) {
            finalSearchResult = [
              ...aggregatedCategorySearchResult ?? []
            ];
          } else if (nonAggregatedCategorySuggestions.length > 0) {
            // AND non-aggregated & aggregated search result
            finalSearchResult = intersectionBy(nonAggregatedCategorySearchResult, aggregatedCategorySearchResult, 'accountid');
          }
        }
      }

      return {finalSearchResult, pagingInfo, hasMoreRecords};
    }

    private async runGlobalSearchTask(fetchXML: string, pageNumber: number = 0, pageSize: number = 50, pageCookie: string = null): Promise<any> {
      let response: any;
      try {
        if (fetchXML) {
          let x = await this.dynamics.executeFetchXml('accounts', fetchXML, undefined, pageNumber, pageCookie);
          response = x;
        }
      } catch (error) {
        console.error('account data service: runGlobalSearchTask: ', error);
      }
      return response;
    }

    async postGlobalSearchedAccountToUserPosition(
      accountId: string,
      customerPositionPayload: { indskr_reason?: string, indskr_skipapproval?: boolean } = {}
    ): Promise<boolean> {
      let mapSuccess: boolean = false;

      if (accountId) {
        const targetPositionId = this.authService.user.xPositionID;
        let url = this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.accounts.MAP_ACCOUNT_TO_USER_POSITION;
        url = url.replace('{{accountId}}', accountId);
        url = url.replace('{{positionId}}', targetPositionId);

        try {
          // Service does not return any response if succeeds
          await this.http.post(url, customerPositionPayload).toPromise();
          mapSuccess = true;
        } catch (error) {
          console.error('mapGlobalSearchedAccountToUserPosition: ', error);
          if (
            error?.error?.errorMessage?.includes('Duplicate Detected')
          ) {
            throw error;
          }
        }
      }

      return mapSuccess;
    }

    public async createVeevaAccount(entity: any): Promise<any> {
      const url = this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.accounts.CREATE_VEEVA_ACCOUNT;
      let headers = new HttpHeaders();
      if (!entity.isNew) {
        headers = headers.set("X-PositionId", this.authService.user.xPositionID);
      }
      return await this.http.post(url, [entity], { headers }).toPromise();
    }

    public async uploadAccountNotesOnline(): Promise<any> {
      return new Promise(async (resolve,reject)=> {
        let offlineNotes = await this.disk.retrieve(DB_KEY_PREFIXES.OFFLINE_ACCOUNT_NOTES);
        // Try to retrieve from chunks first, then fall back to regular retrieve
        let dbNotesRaw = await this.disk.retrieveFromChunks(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + OFFLINE_DB_LINKED_ENTITY_NAME.ACCOUNT_NOTES);
        let dbNotes = null;
        if (dbNotesRaw) {
          dbNotes = { raw: dbNotesRaw };
        } else {
          // Fall back to old non-chunked format
          dbNotes = await this.disk.retrieve(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + OFFLINE_DB_LINKED_ENTITY_NAME.ACCOUNT_NOTES);
        }
        if(offlineNotes && offlineNotes.raw && Array.isArray(offlineNotes.raw) && offlineNotes.raw.length != 0){
          const payload = offlineNotes.raw.filter(item => item.pendingPushOnDynamics).map(item=>{
          if(item.annotationid.includes('offlineaccountnote')) {
            return {
              accountid: item.accountid,
              createdon: item.createdon,
              notetext: item.notetext,
              ownerid: item.ownerid,
              filename: item.filename,
              filesize: item.filesize,
              documentbody: item.documentbody,
              mimetype: item.mimetype
            };
          } else {
            if(item.deleted){
              return {
                deleted: true,
                noteid: item.annotationid
              };
            } else if(item.fileupdated){
              return {
                notetext: item.notetext,
                noteid: item.annotationid,
                filename: item.filename,
                filesize: item.filesize,
                documentbody: item.documentbody,
                mimetype: item.mimetype
              };
            } else if(item.fileremoved){
              return {
                notetext: item.notetext,
                noteid: item.annotationid,
                filename: item.filename,
                filesize: item.filesize,
                documentbody: item.documentbody,
                mimetype: item.mimetype
              };
            } else {
              return {
                notetext: item.notetext,
                noteid: item.annotationid
              };
            }
          }
        });
        const url = this.authService.userConfig.activeInstance.entryPointUrl + Endpoints.accounts.UPLOAD_ACCOUNT_NOTES;
        const response = await this.http.post(url, payload, Endpoints.headers.content_type.json).toPromise();
        if(response && Array.isArray(response) && response.length != 0){
          response.forEach((note,idx) => {
            if(note.hasOwnProperty('noteid')){
              // Add to real offline db for customer notes
              try {
                if (dbNotes && dbNotes.raw && Array.isArray(dbNotes.raw) && dbNotes.raw.length != 0) {
                  const dbIdx = dbNotes.raw.findIndex(item => item['annotation.annotationid'] == note['noteid']);
                  if(payload[idx].deleted == true){
                    dbNotes.raw.splice(dbIdx,1);
                  } else {
                    if (dbIdx >= 0) {
                      dbNotes.raw[dbIdx]['annotation.annotationid'] = note['noteid'];
                      dbNotes.raw[dbIdx]['annotation.notetext'] = offlineNotes.raw[idx]['notetext'];
                      dbNotes.raw[dbIdx]['annotation.filename'] = offlineNotes.raw[idx]['filename'];
                      dbNotes.raw[dbIdx]['annotation.mimetype'] = offlineNotes.raw[idx]['mimetype'];
                    } else {
                      dbNotes.raw.push({
                        'annotation.annotationid': note['noteid'],
                        'annotation.objectid': offlineNotes.raw[idx]['accountid'],
                        'accountid': offlineNotes.raw[idx]['accountid'],
                        'annotation.createdon': new Date(parseInt(offlineNotes.raw[idx]['createdon'])),
                        'annotation.notetext': offlineNotes.raw[idx]['notetext'],
                        'annotation.ownerid@OData.Community.Display.V1.FormattedValue':offlineNotes.raw[idx]['ownerName'],
                        'annotation.ownerid':offlineNotes.raw[idx]['ownerid'],
                        'annotation.filename': offlineNotes.raw[idx]['filename'],
                        "annotation.mimetype": offlineNotes.raw[idx]['mimetype']
                      });
                    }
                  }
                } else if (payload[idx].deleted != true) {
                  dbNotes = {
                    raw : [{
                      'annotation.annotationid': note['noteid'],
                      'annotation.objectid': offlineNotes.raw[idx]['accountid'],
                      'accountid': offlineNotes.raw[idx]['accountid'],
                      'annotation.createdon': new Date(parseInt(offlineNotes.raw[idx]['createdon'])),
                      'annotation.notetext': offlineNotes.raw[idx]['notetext'],
                      'annotation.ownerid@OData.Community.Display.V1.FormattedValue':offlineNotes.raw[idx]['ownerName'],
                      'annotation.ownerid':offlineNotes.raw[idx]['ownerid'],
                      'annotation.filename': offlineNotes.raw[idx]['filename'],
                      "annotation.mimetype": offlineNotes.raw[idx]['mimetype']
                    }]
                  }
                }
                offlineNotes.raw[idx].pendingPushOnDynamics = false;
              } catch (error) {
                  console.log(error);
              }
            }
          });
          offlineNotes.raw = offlineNotes.raw.filter(item => item.pendingPushOnDynamics);
          offlineNotes.count = offlineNotes.raw.length;
          this.disk.setOfflineDataCount(OFFLINE_DATA_COUNT_ENTITY_NAME.ACCOUNT_NOTES, offlineNotes.count);
          await this.disk.updateOrInsert(DB_KEY_PREFIXES.OFFLINE_ACCOUNT_NOTES, doc => {
              doc = offlineNotes;
              return doc;
          }).catch(error => console.error('Save Account Notes to DB error: ', error));

          if(dbNotes){
              // Use chunked saving for large datasets to avoid heap memory issues
              // Using array length as threshold instead of calculating byte size (which can cause memory issues)
              const dbNotesArray = dbNotes.raw || [];
              const USE_CHUNKED_SAVING = true;
              const CHUNK_SIZE_THRESHOLD_ITEMS = 5000; // Save in chunks if array has more than 500 items
              
              if (USE_CHUNKED_SAVING && Array.isArray(dbNotesArray) && dbNotesArray.length > CHUNK_SIZE_THRESHOLD_ITEMS) {
                await this.disk.saveInChunks(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + OFFLINE_DB_LINKED_ENTITY_NAME.ACCOUNT_NOTES, dbNotesArray, CHUNK_SIZE_THRESHOLD_ITEMS)
                  .catch(error => console.error('Save Account Notes Linked Entity to DB (chunked) error: ', error));
              } else {
                await this.disk.updateOrInsert(DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + OFFLINE_DB_LINKED_ENTITY_NAME.ACCOUNT_NOTES, doc => {
                    doc = dbNotes;
                    return doc;
                }).catch(error => console.error('Save Account Notes Linked Entity to DB error: ', error));
              }
          }
        }
        resolve(response);
      } else {
        resolve(null);
      }
    });
  }

  async syncAllTags(loadFromDbOnly = false) {
    let offlineFallback: boolean = this.device.isOffline || loadFromDbOnly;
    if (offlineFallback) {
      const tasks: Promise<void>[] = [];
      const safeAsyncTask = async (label: string, task: Promise<any>) => {
        try {
          await task;
        } catch (error) {
          console.error(`Error executing sync in ${label}: `, error);
        }
      };

      tasks.push(safeAsyncTask('account tags', this.loadAccountTagFromDB()));
      tasks.push(safeAsyncTask('contact tags', this.contactService.loadContactTagFromDB()));
      tasks.push(safeAsyncTask('presentation tags', this.presentationService.loadPresentationTagFromDB()));
      tasks.push(safeAsyncTask('resource tags', this.resourceService.loadResourceTagFromDB()));

      await Promise.all(tasks);
    } else {
      const syncState = await this.disk.getSyncState(DB_SYNC_STATE_KEYS.SYNC_ACCOUNT_TAG);
      const isInitialSync = !syncState || !syncState.lastUpdatedTime;
      let lastUpdatedTime = syncState?.lastUpdatedTime;
      const accountTagsSyncInfo: EntitySyncInfo = {
        entityName: EntityNames.account_tag,
        totalFailed: 0,
        totalSynced: 0,
        errors: [],
        syncStatus: true
      };
      if (isInitialSync) {
        await this.AllTagInitialSync();
      } else {
        await this.AllTagDeltaSync(lastUpdatedTime)
      }
      const newLastUpdatedTime = new Date().getTime().toString();
      syncState.lastUpdatedTime = newLastUpdatedTime;
      await this.disk.updateSyncState(syncState);
      if (Array.isArray(this.userTagService.accountTags)) {
        accountTagsSyncInfo.totalSynced = this.userTagService.accountTags.length;
      }
      this.deltaService.addEntitySyncInfo(accountTagsSyncInfo);
      // Update sync state for the other tags. The currently implemented code relies on account tag sync state to determine whether to perform an initial or delta sync. 
      // This appears to have been implemented while integrating tag fetch logic, and the need for sync status for other tags needs to be reviewed. 
      // Currently, only bug-related issues are covered.
      this.contactService.updateSyncStateCustomerTag(newLastUpdatedTime);
      this.presentationService.updateSyncStatePresentationTag(newLastUpdatedTime);
      this.resourceService.updateSyncStateResourceTag(newLastUpdatedTime);
    }
  }

  private async loadAccountTagFromDB() {
    try {
      const data = await this.disk.batchFetch(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_USER_TAG);
      if (Array.isArray(data)) {
        this.userTagService.accountTags = data?.filter(a => a.entity === TagEntityType.ACCOUNT);
      }
    } catch (error) {
      console.error('Error loading account tags from DB:', error);  
    }
  }

  private async AllTagInitialSync() {
    try {
      await this.disk.deleteAllFromDbUsingAlldocsQuery(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_USER_TAG);
      await this.disk.deleteAllFromDbUsingAlldocsQuery(DB_ALLDOCS_QUERY_OPTIONS.GET_ALL_CUSTOMER_TAG);

      const positionIds = this.authService.user.positions.map(o => {
        return o.ID
      });
      const buId = this.authService.user.buConfigs.indskr_bulevelconfigurationid;
      let positionString = '';
      positionIds.forEach(p => {
        positionString += '<value>' + p + '</value>';
      })
      let PrivateTagfetchXml = fetchQueries.allUserTag.fetchPrivateTags;
      let publicTagfetchXml = fetchQueries.allUserTag.fetchPublicTags;
      let assignedTagfetchXml=fetchQueries.allUserTag.fetchAssignedTagsPosition.replace(/{positionIDs}/g, `${positionString}`);
      let assignButagfetchXml = fetchQueries.allUserTag.fetchAssignedTagsForBU.replace(/{busUnitID}/g, `${this.authService.user.buConfigs.indskr_bulevelconfigurationid}`).replace(/{positionIDs}/g, `${positionString}`);
      await Promise.all([
        this.dynamics.executeFetchQuery('indskr_usertags', PrivateTagfetchXml),
        this.dynamics.executeFetchQuery('indskr_usertags', publicTagfetchXml),
        this.dynamics.executeFetchQuery('indskr_usertags', assignedTagfetchXml),
        this.dynamics.executeFetchQuery('indskr_usertags', assignButagfetchXml)
      ]).then(async response => {
        let privateTag = response[0];
        let publicTag = response[1];
        let assignedTag =response[2];
        let assignedTagBu =response[3];

        let allTags = privateTag.concat(publicTag,assignedTag,assignedTagBu);
        const categorisedTags = this.getCategoriesedTags(allTags);
        //account 
        const accountTagDetailsResponse = categorisedTags.accountTagDetailsResponse;
        let accountIdList = this.getAccountIdsForTagIds(accountTagDetailsResponse);
        let accountTagDetails = accountTagDetailsResponse.map((tag) => {
          return new UserTag(tag.indskr_externalid, tag.indskr_usertagid, tag.deleted, tag.indskr_name,
            accountIdList[tag.indskr_usertagid], false, TagStateCode.Active, TagEntityType.ACCOUNT,tag.indskr_visibility , tag.indskr_filter ,tag.indskr_allowusertomodifytag)
        });
        accountTagDetails = uniqBy(accountTagDetails, 'indskr_usertagid');
        this.userTagService.accountTags = accountTagDetails;
        this.userTagService.accountTags = uniqBy(this.userTagService.accountTags,"indskr_usertagid");
        this.userTagService.accountTags = this.userTagService.sortUserTags(this.userTagService.accountTags);
        
        await this.disk.upsertUserTagListToDisk(accountTagDetails);

        // contact
        const contactTagDetailsResponse = categorisedTags.contactTagDetailsResponse;
        let contactIdList = this.getContractIdsForTagIds(contactTagDetailsResponse)
        console.log(contactIdList);
        let contactTagDetails = contactTagDetailsResponse.map((tag) => {
          return new UserTagForContact(tag.indskr_externalid, tag.indskr_usertagid, tag.deleted, tag.indskr_name,
            contactIdList[tag.indskr_usertagid], false, tag.statecode,tag.indskr_visibility,tag.indskr_filter ,tag.indskr_allowusertomodifytag)
        });
        contactTagDetails = uniqBy(contactTagDetails, 'indskr_usertagid');
        this.contactOfflineService.contactTags = contactTagDetails;
        this.contactOfflineService.contactTags =  sortBy(this.contactOfflineService.contactTags , tag => (tag.indskr_name || "").toLowerCase());
        await this.disk.upsertUserTagListToDisk(contactTagDetails, TagEntityType.CONTACT);
        
        // presentation
        const presentationTagDetailsResponse = categorisedTags.presentationTagDetailsResponse;
        let presentationIdList = this.getpresentationIdsForTagIds(presentationTagDetailsResponse)
        let presentationTagDetails = presentationTagDetailsResponse.map((tag) => {
          return new UserTag(tag.indskr_externalid, tag.indskr_usertagid, tag.deleted, tag.indskr_name,
            presentationIdList[tag.indskr_usertagid], false, TagStateCode.Active, TagEntityType.PRESENTATION, tag.indskr_visibility , tag.indskr_filter ,tag.indskr_allowusertomodifytag)
        });
        presentationTagDetails = uniqBy(presentationTagDetails, 'indskr_usertagid');
        this.userTagService.PresentationTags = presentationTagDetails;
        this.userTagService.PresentationTags = this.userTagService.sortUserTags(this.userTagService.PresentationTags);
        this.userTagService.PresentationTags = uniqBy(this.userTagService.PresentationTags,"indskr_externalid")
        await this.disk.upsertUserTagListToDisk(presentationTagDetails)

        //Resource
        const resourceTagDetailsResponse = categorisedTags.resourceTagDetailsResponse;
        let resourceIdList = this.getresourceIdsForTagIds(resourceTagDetailsResponse)
        let resourceTagDetails = resourceTagDetailsResponse.map((tag) => {
          return new UserTag(tag.indskr_externalid, tag.indskr_usertagid, tag.deleted, tag.indskr_name,
            resourceIdList[tag.indskr_usertagid], false, TagStateCode.Active, TagEntityType.RESOURCE, tag.indskr_visibility,tag.indskr_filter ,tag.indskr_allowusertomodifytag)
        });
        resourceTagDetails = uniqBy(resourceTagDetails, 'indskr_usertagid');
        this.userTagService.resourceTag = resourceTagDetails;
        this.userTagService.resourceTag = this.userTagService.sortUserTags(this.userTagService.resourceTag);
        await this.disk.upsertUserTagListToDisk(resourceTagDetails)
      })
    }
    catch (e) {
      console.log(e);
    }
  }

  private getCategoriesedTags(allTags): any {
    let accountTagDetailsResponse = [];
    let contactTagDetailsResponse = [];
    let presentationTagDetailsResponse = [];
    let resourceTagDetailsResponse = [];

    for (let tag of allTags) {
      if (tag['indskr_taggedfor']) {
        if (!tag['indskr_externalid']) {
          tag['indskr_externalid'] = tag['indskr_usertagid'];
        }
        if (tag['indskr_taggedfor'].toLowerCase() === "account") {
          accountTagDetailsResponse.push(tag);
        } else if (tag['indskr_taggedfor'].toUpperCase() === "CONTACT") {
          contactTagDetailsResponse.push(tag);
        } else if (tag['indskr_taggedfor'].toLowerCase() === "presentation") {
          presentationTagDetailsResponse.push(tag);
        } else if (tag['indskr_taggedfor'].toLowerCase() === "resource") {
          resourceTagDetailsResponse.push(tag);
        }
      }
    }

    return { accountTagDetailsResponse, contactTagDetailsResponse, presentationTagDetailsResponse, resourceTagDetailsResponse };
  }

  private async AllTagDeltaSync(lastUpdatedTime) {
    const tasks: Promise<void>[] = [];
    const safeAsyncTask = async (label: string, task: Promise<any>) => {
      try {
        await task;
      } catch (error) {
        console.error(`Error executing sync in ${label}: `, error);
      }
    };

    tasks.push(safeAsyncTask('account tags', this.loadAccountTagFromDB()));
    tasks.push(safeAsyncTask('contact tags', this.contactService.loadContactTagFromDB()));
    tasks.push(safeAsyncTask('presentation tags', this.presentationService.loadPresentationTagFromDB()));
    tasks.push(safeAsyncTask('resource tags', this.resourceService.loadResourceTagFromDB()));

    await Promise.all(tasks);

    const positionIds = this.authService.user.positions.map(o => {
      return o.ID
    });
    let positionString = '';
    positionIds.forEach(p => {
      positionString += '<value>' + p + '</value>';
    })
    let PrivateTagfetchXml = fetchQueries.allUserTag.updatedPrivateTags;
    let publicTagfetchXml = fetchQueries.allUserTag.updatedPublicTags;
    let assignedTagfetchXml= fetchQueries.allUserTag.updatedAssignedTagPosition.replace(/{positionIDs}/g, `${positionString}`);
    let assignButagfetchXml = fetchQueries.allUserTag.updatedAssignedTagsForBU.replace(/{busUnitID}/g, `${this.authService.user.buConfigs.indskr_bulevelconfigurationid}`).replace(/{positionIDs}/g, `${positionString}`);
    let emptyBuAndPosition = fetchQueries.allUserTag.updatedEmptyBuAndPosition;
    
    lastUpdatedTime = new Date(parseInt(lastUpdatedTime)).toISOString();
    PrivateTagfetchXml = PrivateTagfetchXml.replace('{lastUpdatedTime}', lastUpdatedTime)
    publicTagfetchXml = publicTagfetchXml.replace('{lastUpdatedTime}', lastUpdatedTime)
    assignedTagfetchXml = assignedTagfetchXml.replace('{lastUpdatedTime}', lastUpdatedTime)
    assignButagfetchXml = assignButagfetchXml.replace('{lastUpdatedTime}', lastUpdatedTime)
    emptyBuAndPosition = emptyBuAndPosition.replace('{lastUpdatedTime}', lastUpdatedTime)
    let deletedUserTagsFetchXml = CONTACT_FETCH_QUERIES.deletedUserTagsFetchXml;
    deletedUserTagsFetchXml = deletedUserTagsFetchXml.replace('{lastUpdatedTime}', lastUpdatedTime).replace('{userId}', `${this.authService.user.xSystemUserID}`)
    await Promise.all([
      this.dynamics.executeFetchQuery('indskr_usertags', PrivateTagfetchXml),
      this.dynamics.executeFetchQuery('indskr_usertags', publicTagfetchXml),
      this.dynamics.executeFetchQuery('indskr_usertags', assignedTagfetchXml),
      this.dynamics.executeFetchQuery('indskr_usertags', assignButagfetchXml),
      this.dynamics.executeFetchQuery('indskr_trackchanges', deletedUserTagsFetchXml),
      this.dynamics.executeFetchQuery('indskr_usertags', emptyBuAndPosition)
    ]).then(response => {
      let privateTag = response[0];
      let publicTag = response[1];
      let assignedTag =response[2];
      let assignedTagBu =response[3];
      let emptyBuAndPos =response[5];
      let allTag = privateTag.concat(publicTag,assignedTag,assignedTagBu,emptyBuAndPos);
      let categorisedTags = this.getCategoriesedTags(allTag);
      
      const updateAccountTags = categorisedTags.accountTagDetailsResponse;
      const updateContactTags =  categorisedTags.contactTagDetailsResponse;
      const updatePresentationTags = categorisedTags.presentationTagDetailsResponse;
      const updateResourceTags = categorisedTags.resourceTagDetailsResponse;
      if(updateAccountTags.length>0) this.accountTagMap(updateAccountTags,response[4],positionIds);
      if(updateContactTags.length>0) this.contactTagMap(updateContactTags,response[4],positionIds);
      if(updatePresentationTags.length>0) this.PresentationTagMap(updatePresentationTags,response[4],positionIds);
      if(updateResourceTags.length>0) this.ResourceTagMap(updateResourceTags,response[4],positionIds);
      
    })
      .catch((e) => { 
        console.error('uploadOfflineData: ', e); 
        return false; 
      });
  }

  private getAccountIdsForTagIds(updateAccountTags: any[]) {
    return updateAccountTags.reduce((data, val) => {
      data[val.indskr_usertagid] = data[val.indskr_usertagid] || [];
      let accountId = new EntityTag(val["accountId"])
      if (accountId) {
        if (accountId.id) {
          data[val.indskr_usertagid].push(accountId)
        }
      } else if (!data[val.indskr_usertagid].length) {
        data[val.indskr_usertagid] = []
      }
      return data;
    }, {});
  }

  private getContractIdsForTagIds(updateContactTags: any[]) {
    return updateContactTags.reduce((data, val) => {
      data[val.indskr_usertagid] = data[val.indskr_usertagid] || [];
      let contactId = new ContactTag(val["contactId"])
      if (contactId) {
        data[val.indskr_usertagid].push(contactId)
      } else if (!data[val.indskr_usertagid].length) {
        data[val.indskr_usertagid] = []
      }
      return data;
    }, {});
  }

  private getpresentationIdsForTagIds(updatePresentationTags: any[]) {
    return updatePresentationTags.reduce((data, val) => {
      data[val.indskr_usertagid] = data[val.indskr_usertagid] || [];
      let presentationId = new EntityTag(val["presentationId"])
      if (presentationId) {
        if (presentationId.id) {
          data[val.indskr_usertagid].push(presentationId)
        }
      } else if (!data[val.indskr_usertagid].length) {
        data[val.indskr_usertagid] = []
      }
      return data;
    }, {});
  }

  private getresourceIdsForTagIds(updateResourceTags: any[]) {
    return updateResourceTags.reduce((data, val) => {
      data[val.indskr_usertagid] = data[val.indskr_usertagid] || [];
      let resourceId = new EntityTag(val["resourceId"]);
      let documentId = new EntityTag(val["documentId"]);
      if (resourceId || documentId) {
        if (resourceId.id) {
          data[val.indskr_usertagid].push(resourceId)
        }
        if (documentId.id) {
          data[val.indskr_usertagid].push(documentId)
        }
      } else if (!data[val.indskr_usertagid].length) {
        data[val.indskr_usertagid] = []
      }
      return data;
    }, {});
  }

  private getBuForUserTags(tagList: any[]) {
    return tagList.reduce((data, val) => {
      data[val.indskr_usertagid] = data[val.indskr_usertagid] || [];
      let id = val["bu"]
      if (id) {
          data[val.indskr_usertagid].push(id)
        
      } else if (!data[val.indskr_usertagid].length) {
        data[val.indskr_usertagid] = []
      }
      return data;
    }, {});
  }
  private getPosForUserTags(tagList: any[]) {
    return tagList.reduce((data, val) => {
      data[val.indskr_usertagid] = data[val.indskr_usertagid] || [];
      let id = val["position"]
      if (id) {
          data[val.indskr_usertagid].push(id)
        
      } else if (!data[val.indskr_usertagid].length) {
        data[val.indskr_usertagid] = []
      }
      return data;
    }, {});
  }
  async uploadOfflineAccountTag(isPartialUpload = false, maxRecordCountForPartialUpload = 10) {
    if (!isPartialUpload && this.device.isOffline) return;
    let option = {
      selector: {
        '_id': {
          $gte: DB_KEY_PREFIXES.USER_TAG,
          $lte: DB_KEY_PREFIXES.USER_TAG + PREFIX_SEARCH_ENDKEY_UNICODE
        },
        'pendingPushToDynamics': { $eq: true }
      }
    };

    try {
      let userTags: UserTag[] = await this.disk.find(option);
      if (userTags && userTags.length) {
        if (isPartialUpload) {
          if (userTags.length > maxRecordCountForPartialUpload) {
            userTags = userTags.splice(0, maxRecordCountForPartialUpload);
          }
        }
        await this.userTagService.uploadOfflineData(userTags).subscribe(response => {
          if (response) {
            response.forEach(async res => {
              let data = res;
              const indskr_externalid = data['indskr_externalid'];
              const index = userTags.findIndex(tag => tag.indskr_externalid === indskr_externalid);
              if (index > -1) {
                userTags[index].pendingPushToDynamics = false;
                userTags[index].indskr_usertagid = data['indskr_usertagid'];
                if (userTags[index].deleted) {
                  await this.disk.remove(DB_KEY_PREFIXES.USER_TAG + userTags[index].indskr_externalid);
                }
              }
            
              let tagPres = this.userTagService.PresentationTags.find(x=>x.indskr_externalid == indskr_externalid )
              if(tagPres) tagPres.indskr_usertagid = data['indskr_usertagid'];
              let tagAcc = this.userTagService.accountTags.find(x=>x.indskr_externalid == indskr_externalid )
              if(tagAcc)tagAcc.indskr_usertagid = data['indskr_usertagid'];
            });
          }
        }, error => {
          console.error(error);
        });
        const newCount = userTags.filter(userTag => userTag.pendingPushToDynamics);
        this.disk.subtractOfflineDataCount(OFFLINE_DATA_COUNT_ENTITY_NAME.USER_TAG, newCount ? newCount.length : 0);
      }

    } catch (err) {
      console.error("Failed to upload offline Account tag: ", err);
    }

  }

   /** Filter lineked Entity data to use affiliated account-contact selection via global search */
   public async getSelectableLinkedEntity(dbKey:string, referenceEntity:string, selectedId:string, secondaryinfoFetchXml: string = ''): Promise<SelectableLinkedEntity[]> {
    let selectableLinkedEntity: Array<SelectableLinkedEntity> = [];
    try {
      const response = await this.fetchAccountsSpecificLinkEntityData(dbKey, selectedId, secondaryinfoFetchXml);

      const subKey: string = 'contactaffiliation';
      const attrStatecodeStr: string = dbKey + '.statecode';
      const attrSelIdStr: string = dbKey + '.indskr_contactid';
      const attrIsPrimaryStr: string = dbKey + '.indskr_isprimaryaccount';
      const attrSelNameStr: string = dbKey + '.indskr_contactid_Formatted';
      const attrApprovalStatusStr: string = 'cp' + '.indskr_approvalstatus';
      const attrPositionIdStr: string = 'cp' + '.indskr_positionid';
      const userPositionId: string = this.authService.user.xPositionID;
      const customerPositionStatecode: string = 'cp' + '.statecode';
      const modifiedOnStr: string = dbKey + '.modifiedon';
      const createdOnStr: string = dbKey + '.createdon';
      const entityImageStr: string = `${subKey}.entityimage`;
      const firstNameStr: string = `${subKey}.firstname`;
      const lastNameStr: string = `${subKey}.lastname`;
      const fullNameStr: string = `${subKey}.fullname`;
      
      if(!isEmpty(response)) {
        const linkedEntityData = response.filter(x=>x[referenceEntity] == selectedId && (!x.hasOwnProperty(attrStatecodeStr) || (x.hasOwnProperty(attrStatecodeStr) && x[attrStatecodeStr] == 0)));
        
        if(!isEmpty(linkedEntityData)) {
          const isReasonFieldEnabled = this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_MAPPING_APPROVAL);
          
          linkedEntityData.forEach(le=>{
            let approvalStatusValue: string = '';
            let sequenceName: string = '';

            if(isReasonFieldEnabled) {
              if(le[attrPositionIdStr] && le[attrPositionIdStr] == userPositionId) {
                if (le[attrApprovalStatusStr]) {
                  if (le[attrApprovalStatusStr] == APPROVAL_STATUS.FOR_REVIEW) {
                    approvalStatusValue = this.translate.instant("SUBMITTED_FOR_APPROVAL");
                  } else if (le[attrApprovalStatusStr] == APPROVAL_STATUS.DRAFT) {
                    approvalStatusValue = this.translate.instant("REJECTED_BY_APPROVER");
                  }
                }
              }
            }
            if (le[customerPositionStatecode] && le[customerPositionStatecode] == 1) {
              approvalStatusValue = this.translate.instant("APPROVAL_DEACTIVATED");
            }
            // contact name
            if (le[firstNameStr] || le[lastNameStr]) {
              sequenceName = this.contactOfflineService.getFullNameForContactDisplaySequenceByName(le[firstNameStr], le[lastNameStr]);
            }

            if (!sequenceName) {
              sequenceName = le[attrSelNameStr] || le[fullNameStr] || '';
            }


            // Configured secondary information
            const formatedSecondaryInfo: string = this.secondaryInfoService.getSecondaryInfoFormatedTextForLinkedEntity(le, SecondaryInfoEntityName.Contact);

            selectableLinkedEntity.push({
              selId: le[attrSelIdStr] || '',
              isPrimary: le[attrIsPrimaryStr] || false,
              selName: sequenceName,
              isDisableChkBox: false,
              isChecked: false,
              approvalStatus: approvalStatusValue,
              image: le[entityImageStr] ? this.getFormattedEntityImageString(le[entityImageStr]) : '',
              initial: this.getInitials(sequenceName),
              secondaryInfo: formatedSecondaryInfo,
              modifiedOn: le[modifiedOnStr] ? new Date(le[modifiedOnStr]) : le[createdOnStr] ? new Date(le[createdOnStr]) : new Date()
            });
          });
          
          if(isReasonFieldEnabled) {
            selectableLinkedEntity = orderBy(selectableLinkedEntity, ['approvalStatus', 'modifiedOn'], 'desc');
          } else {
            selectableLinkedEntity = orderBy(selectableLinkedEntity, ['modifiedOn'], 'desc');
          }
          selectableLinkedEntity = uniqBy(selectableLinkedEntity, 'selId');
        }
      }

      return selectableLinkedEntity;
    
    } catch(error) {
      console.error("Failed to fetch linked entity data: ", error);
      return selectableLinkedEntity;
    }
  }

  async fetchAccountsSpecificLinkEntityData(targetLinkedEntity: string, accountId, secondaryinfoFetchXml: string = '') {
    let filteredData = [];
    await Promise.all(
      FETCH_ACCOUNTS_LINK_ENTITES_BY_ACCOUNTID.map(async (linkEntity) => {
        if (targetLinkedEntity != linkEntity.entityName) return;
        let accountFilter = `<filter><condition attribute="indskr_accountid" operator="eq" value="{0}" /></filter>`
        let fetchXML = linkEntity.fetchXML;
        fetchXML = fetchXML.replace('{AccountFilter}', accountFilter);
        fetchXML = fetchXML.replace('{0}', accountId);
        fetchXML = fetchXML.replace('{secondaryinfoFetchXml}', secondaryinfoFetchXml);

        try {
          const res = await this.dynamics.executeFetchQuery("accounts", fetchXML);
          if(!isEmpty(res)) {
            let dataToSave = '';
            if ((accountId) && Array.isArray(res)) {
              // Chunk-aware read. This key can be stored either way, and reading only the
              // single-document shape made a chunked store look absent - which then skipped
              // the write below entirely (see isUpdated) and, worse, would let a reseed wipe
              // the chunks. Match the order every other reader of this store uses.
              let localRaw: any = await this.disk.retrieveFromChunks(linkEntity.entityName);
              if (!localRaw) {
                const temp = await this.disk.retrieve(linkEntity.entityName);
                localRaw = temp?.raw ?? [];
              }
              const leIdAttrName = linkEntity.entityName + "." + linkEntity.entityName + "id";
              const lePositionIdStr = 'cp.indskr_positionid';
              {
                // Previously guarded by `if (!isEmpty(temp))`, so on a fresh install - before
                // any sync had created this document - the merged rows were computed and then
                // thrown away, and the store stayed empty for good. Seeding from an empty array
                // makes every row count as new, so the first fetch creates the document.
                let isUpdated: boolean = false;
                res.forEach(rawRes => {
                  if (rawRes && rawRes.hasOwnProperty('accountid') && rawRes.hasOwnProperty(leIdAttrName)) {
                    rawRes = omitBy(rawRes, (value, key) => key.endsWith('@OData.Community.Display.V1.AttributeName')
                      || key.endsWith('@Microsoft.Dynamics.CRM.lookuplogicalname')
                      || key.endsWith('_LogicalName')
                      );
                    let idx = localRaw.findIndex(a => a && a.hasOwnProperty('accountid') && a[leIdAttrName] == rawRes[leIdAttrName] && a[lePositionIdStr] == rawRes[lePositionIdStr]);
                    if (idx >= 0) {
                      isUpdated = true;
                      if (rawRes['statecode'] == 1 && rawRes['statuscode'] == 2) {
                        localRaw.splice(idx, 1);
                      } else {
                        localRaw[idx] = rawRes;
                      }
                    } else {
                      if (rawRes['statuscode'] != 2) {
                        isUpdated = true;
                        localRaw.push(rawRes);
                      }
                    }
                  }
                });
                dataToSave = localRaw;
                if (isUpdated && !isEmpty(dataToSave)) {
                  await this.disk.saveLinkedEntityData(linkEntity.entityName, dataToSave as any)
                    .catch(error => console.error('Save Updated LE to DB error: ', error));
                }
              }
              // Populate return value with original res (preserves _Formatted fields needed
              // by getSelectableLinkedEntity for contact name display)
              res.forEach(rawRes => {
                if (rawRes['statuscode'] != 2) {
                  filteredData.push(rawRes);
                }
              });
            }
          }
        } catch (error) {
          console.error("Failed to fetch linked entity data: ", error);
        }
      })
    );
    return filteredData;
  }

  public getFormattedEntityImageString(entityimage): string {
    return "data:image/jpeg;base64," + entityimage;
  }

  private getAccountImage = batched(async (accountIds) => {
      type responseType = {value: {accountid: string, entityimage: string}[]};
      const resp: responseType = await this.dynamics.retrieveAll('accounts', ['entityimage'],
      `Microsoft.Dynamics.CRM.In(PropertyName='accountid',PropertyValues=['${accountIds.map(a => a.id).join("','")}'])`);
      return resp?.value?.map(c => ({
        id: c.accountid,
        result: c.entityimage ? this.getFormattedEntityImageString(c.entityimage) : null
      })) ?? [];
  }, 100);

  public async getEntityImageStringForAccount (account:Account, hardRefresh:boolean = false){
    if(account && account.id && (!account.entityImage || hardRefresh)){
      return this.getAccountImage(account);
    }else if(account && account.entityImage){
      return account.entityImage;
    }
  }

  // --------------------------------Team Users - Filter levels-------------------------------- //
  public async getTargetAccountsBasedOnPositionId(positionId: string) : Promise<AccountGlobalSearchDTO[]> {
    console.log(`getTargetAccountsBasedOnPositionId`);
    let response:AccountGlobalSearchDTO[] = [];

    try {
      const todayDate = this.dateService.formatDate(new Date(), "YYYY-MM-DD");
      let fetchXML = fetchQueries.fetchTargetAccountsBasedOnPositionId
       .replace('{date}', todayDate)
      .replace('{date}', todayDate)
      .split('{positionID}').join(positionId);
      fetchXML = fetchXML.replace('{secondaryinfoFetchXml}', this.secondaryInfoService.SecondaryInfoFetchXML(SecondaryInfoEntityName.Account));

      response = await this.dynamics.executeFetchQuery('accounts', fetchXML);
      response = orderBy(uniqBy(response, 'accountid'), ['name'],['asc']);
      console.warn(`getTargetAccountsBasedOnPositionId: executeFetchQuery`);
      console.log(response);
    } catch (error) {
      console.error('getTargetAccountsBasedOnPositionId: error:', error);
    }
    return response;
  }

  public async getAccountsBasedOnPositionId(positionId: string): Promise<string[]> {
    console.log(`getAccountsBasedOnPositionId`);
    let response = [];

    let fetchXML = fetchQueries.fetchAccountsBasedOnPositionId;
    fetchXML = fetchXML.replace('{secondaryinfoFetchXml}', this.secondaryInfoService.SecondaryInfoFetchXML(SecondaryInfoEntityName.Account));

    try {
      fetchXML = fetchXML.replace('{positionID}', `${positionId}`);
      response = await this.dynamics.executeFetchQuery('accounts', fetchXML);
      response = orderBy(uniqBy(response, 'accountid'), ['name'],['asc']);
      console.warn(`getAccountsBasedOnPositionId: executeFetchQuery`);
      console.log(response);
    } catch (error) {
      console.error('getAccountsBasedOnPositionId: error:', error);
    }
    return response;
  }

  // fetching only for accounts mapped to user position
  public async fetchCustomerAddresses(fullSync, loadFromDbOnly = false) {
    const offlineData = await this.loadCustomerAddressFromLocalDB();
    let deltaFilter = '';

    if (loadFromDbOnly) {
      this.accountOfflineService.customerAddresses = offlineData.raw ? offlineData.raw : [];
      return;
    }

    let fetchXML = fetchQueries.accounts.customerAddress;

    const positions = this.authService.user.positions.map((o) => {
      return o.ID
    });

    let positionString = '';
    positions.forEach(p => {
      positionString += '<value>' + p + '</value>';
    });

    if (offlineData && offlineData.lastModified) {
      const modifiedon = this.dateService.formatDateForFetchXML(offlineData.lastModified);
      deltaFilter = `<condition attribute="modifiedon" operator="ge" value="` + modifiedon + `"/>`;
    }

    fetchXML = fetchXML.replace('{positionIDs}', positionString);
    fetchXML = fetchXML.replace('{deltaSyncFilter}', !fullSync ? deltaFilter : '');

    if (fullSync) {
      fetchXML = fetchXML.replace('{fullSyncFilter}', '<condition attribute="statecode" operator="eq" value="0" />');
    }

    await this.dynamics.executeFetchQuery('indskr_indskr_customeraddress_v2s', fetchXML).then((response) => {
      if (fullSync && !response.length) this.accountOfflineService.customerAddresses = [];
      
      if (response && response.length > 0) {
        let customerAddresses = response.map((caddress) => new customerAddress(caddress));
        this.accountOfflineService.customerAddresses = customerAddresses; 
        if (fullSync || !this.accountOfflineService.customerAddresses.length) this.accountOfflineService.customerAddresses = customerAddresses;

        if (!fullSync && this.accountOfflineService.customerAddresses.length > 0) {
          customerAddresses.forEach((customerAddress : customerAddress) => {
            const index = this.accountOfflineService.customerAddresses.findIndex(({ customerAddressId }) => customerAddressId === customerAddress.customerAddressId);
            if (index < 0 && customerAddress.statecode === 1) {
              this.accountOfflineService.customerAddresses.push(customerAddress);
            } else if (customerAddress.statecode === 1) { // if customer specialities deactivated remove from local
              this.accountOfflineService.customerAddresses.splice(index, 1);
            } else {
              this.accountOfflineService.customerAddresses[index] = customerAddress;
            }
          });
        }
        this.saveCustomerAddressInLocalDB(customerAddresses);
      }
    }).catch((err) => {
      console.log(err); 
    })
  }

  public async saveCustomerAddressInLocalDB(customerAddresses: any) {
    try {
      await this.disk.updateOrInsert(DB_KEY_PREFIXES.CUSTOMER_ADDRESSES, (doc) => {
        doc = {
          raw: [],
          lastModified: new Date().getTime()
        };
        doc.raw = customerAddresses;
        return doc;
      });
    } catch (error) {
      console.log(error);
    }
  }

  public async loadCustomerAddressFromLocalDB() {
    let offlineDataStored;
    try {
      await this.disk.retrieve(DB_KEY_PREFIXES.CUSTOMER_ADDRESSES, true).then((doc) => {
        offlineDataStored = doc?.raw ? doc : [];
      });
    }
    catch (er) {
      console.error("Failed to load procedure sub types from local db!: ", er)
      offlineDataStored = [];
    }
    return offlineDataStored;
  }

  accountTagMap(updateAccountTags,trackchangeDlt,positionIds){
    updateAccountTags.forEach(record=> {
      if(!record['indskr_externalid']){
        record['indskr_externalid'] = record['indskr_usertagid'];
      }
    });
    let deletedAccountTags = trackchangeDlt;
    if (!isEmpty(deletedAccountTags)) {
      deletedAccountTags.forEach(async trackChangedTag => {
        let index = this.userTagService.accountTags
          .findIndex(tag => (tag.indskr_usertagid === trackChangedTag['indskr_usertagid']));
        if (index >= 0) {
          await this.disk.remove(DB_KEY_PREFIXES.USER_TAG + this.userTagService.accountTags[index].indskr_externalid);
          this.userTagService.accountTags.splice(index, 1);
        }
      });
    }
    if (!isEmpty(updateAccountTags)) {
      let accountIdList = this.getAccountIdsForTagIds(updateAccountTags);
      let accountIdListForBu = this.getBuForUserTags(updateAccountTags);
      let accountIdListForPos = this.getPosForUserTags(updateAccountTags);
      let accountTagDetails: UserTag[] = updateAccountTags.map((tag) => {
        return new UserTag(tag.indskr_externalid, tag.indskr_usertagid, tag.deleted, tag.indskr_name, accountIdList[tag.indskr_usertagid], false, tag.statecode, TagEntityType.ACCOUNT,tag.indskr_visibility ,tag.indskr_filter,tag.indskr_allowusertomodifytag,accountIdListForBu[tag.indskr_usertagid],accountIdListForPos[tag.indskr_usertagid])
      });
      accountTagDetails = uniqBy(accountTagDetails, 'indskr_usertagid');
      let entriesWithBuOrPosition = accountTagDetails.filter(tg=>tg.visibility=="600000000");
       entriesWithBuOrPosition = entriesWithBuOrPosition.filter((resource) =>
          resource.BUs.includes(this.authService.user.buConfigs.indskr_bulevelconfigurationid) || positionIds.some(position => resource.Posiions.includes(position))
        );
      let entriesWithoutBuAndPosition = accountTagDetails.filter(tg=>tg.visibility=="600000000")
      entriesWithoutBuAndPosition = entriesWithoutBuAndPosition.filter(
          (resource) => !resource.BUs.includes(this.authService.user.buConfigs.indskr_bulevelconfigurationid) && !positionIds.every(position => resource.Posiions.includes(position))
        );

      entriesWithBuOrPosition = accountTagDetails.filter(tg=>tg.visibility!="600000000").concat(entriesWithBuOrPosition);
      entriesWithBuOrPosition.forEach(async (tagDetails) => {

        const checkTagIndex = this.userTagService.accountTags.findIndex(tag => tag.indskr_externalid === tagDetails.indskr_externalid)
        if (checkTagIndex > -1) {
          this.userTagService.accountTags.splice(checkTagIndex, 1);
        }
        // if Tag data is updated with contacts
        if (tagDetails.stateCode === TagStateCode.Active) {
          this.userTagService.accountTags.push(tagDetails);
          await this.disk.upsertUserTag(tagDetails, TagEntityType.ACCOUNT);
        } else {
          await this.disk.remove(DB_KEY_PREFIXES.USER_TAG + tagDetails.indskr_externalid);
        }
      });
      entriesWithoutBuAndPosition.forEach(async (tagDetails) => {
        const checkTagIndex = this.userTagService.accountTags.findIndex(tag => tag.indskr_externalid === tagDetails.indskr_externalid)
        if (checkTagIndex > -1) {
          this.userTagService.accountTags.splice(checkTagIndex, 1);
          await this.disk.remove(DB_KEY_PREFIXES.USER_TAG + tagDetails.indskr_externalid);
          
        }
      })
      this.userTagService.accountTags = uniqBy(this.userTagService.accountTags,"indskr_usertagid");
      this.userTagService.accountTags = this.userTagService.sortUserTags(this.userTagService.accountTags);
    }
  }
  contactTagMap(updateContactTags,trackchangeDlt,positionIds){
    updateContactTags.forEach(record=> {
      if(!record['indskr_externalid']){
        record['indskr_externalid'] = record['indskr_usertagid'];
      }
    });
    let deletedContactTags = trackchangeDlt;
    if (!isEmpty(deletedContactTags)) {
      deletedContactTags.forEach(async trackChangedTag => {

        let index = this.contactOfflineService.contactTags
          .findIndex(tag => (tag.indskr_usertagid === trackChangedTag['indskr_usertagid']));

        if (index >= 0) {
          await this.disk.remove(DB_KEY_PREFIXES.CONTACT_TAG + this.contactOfflineService.contactTags[index].indskr_externalid);
          this.contactOfflineService.contactTags.splice(index, 1);
        }
      });
    }
    if (!isEmpty(updateContactTags)) {
      let contactIdList = this.getContractIdsForTagIds(updateContactTags)
      let contactIdListForBu = this.getBuForUserTags(updateContactTags);
      let contactIdListForPos = this.getPosForUserTags(updateContactTags);
        
      let contactTagDetails: UserTagForContact[] = updateContactTags.map((tag) => {
        return new UserTagForContact(tag.indskr_externalid, tag.indskr_usertagid, tag.deleted, tag.indskr_name, contactIdList[tag.indskr_usertagid], false, tag.statecode,tag.indskr_visibility,tag.indskr_filter,tag.indskr_allowusertomodifytag,contactIdListForBu[tag.indskr_usertagid],contactIdListForPos[tag.indskr_usertagid])
      });
      contactTagDetails = uniqBy(contactTagDetails, 'indskr_usertagid');
      let entriesWithBuOrPosition = contactTagDetails.filter((resource) =>
          (resource.BUs.includes(this.authService.user.buConfigs.indskr_bulevelconfigurationid) || positionIds.some(position => resource.Posiions.includes(position))) && resource.visibility=="600000000"
        );
        
      let entriesWithoutBuAndPosition = contactTagDetails.filter(
          (resource) => (!resource.BUs.includes(this.authService.user.buConfigs.indskr_bulevelconfigurationid) && !positionIds.every(position => resource.Posiions.includes(position)))&& resource.visibility=="600000000"
        );
      entriesWithBuOrPosition = contactTagDetails.filter(tg=>tg.visibility!="600000000").concat(entriesWithBuOrPosition);
      entriesWithBuOrPosition.forEach(async (tagDetails) => {

        const checkTagIndex = this.contactOfflineService.contactTags.findIndex(tag => tag.indskr_externalid === tagDetails.indskr_externalid)
        if (checkTagIndex > -1) {
          this.contactOfflineService.contactTags.splice(checkTagIndex, 1);
        }
        // if Tag data is updated with contacts
        if (tagDetails.stateCode === CustomerTagStateCode.Active) {
          this.contactOfflineService.contactTags.push(tagDetails);
          await this.disk.upsertUserTag(tagDetails, TagEntityType.CONTACT);
        } else {
          await this.disk.remove(DB_KEY_PREFIXES.CONTACT_TAG + tagDetails.indskr_externalid);
        }
      });
      entriesWithoutBuAndPosition.forEach(async (tagDetails)=>{
        const checkTagIndex = this.contactOfflineService.contactTags.findIndex(tag => tag.indskr_externalid === tagDetails.indskr_externalid)
        if (checkTagIndex > -1) {
          this.contactOfflineService.contactTags.splice(checkTagIndex, 1);
          await this.disk.remove(DB_KEY_PREFIXES.CONTACT_TAG + tagDetails.indskr_externalid);
        }
      })
      this.contactOfflineService.contactTags = sortBy(this.contactOfflineService.contactTags, tag => (tag.indskr_name || "").toLowerCase());
      this.contactOfflineService.contactTags = uniqBy(this.contactOfflineService.contactTags, "indskr_usertagid");
    }
  }
  
  
  PresentationTagMap(updatePresentationTags,trackchangeDlt,positionIds){
    updatePresentationTags.forEach(record => {
      if (!record['indskr_externalid']) {
        record['indskr_externalid'] = record['indskr_usertagid'];
      }
    });
    let deletedPresentationTags = trackchangeDlt;
    if (!isEmpty(deletedPresentationTags)) {
      deletedPresentationTags.forEach(async trackChangedTag => {
        let index = this.userTagService.PresentationTags
          .findIndex(tag => (tag.indskr_usertagid === trackChangedTag['indskr_usertagid']));
        if (index >= 0) {
          await this.disk.remove(DB_KEY_PREFIXES.USER_TAG + this.userTagService.PresentationTags[index].indskr_externalid);
          this.userTagService.PresentationTags.splice(index, 1);
        }
      });
    }
    if (!isEmpty(updatePresentationTags)) {
      let presentationIdList = this.getpresentationIdsForTagIds(updatePresentationTags);
      let presentationIdListForBu = this.getBuForUserTags(updatePresentationTags);
      let presentationIdListForPos = this.getPosForUserTags(updatePresentationTags);//resourceIdListForBu[tag.indskr_usertagid],resourceIdListForPos[tag.indskr_usertagid]
        
      let presentationTagDetails: UserTag[] = updatePresentationTags.map((tag) => {
        return new UserTag(tag.indskr_externalid, tag.indskr_usertagid, tag.deleted, tag.indskr_name, presentationIdList[tag.indskr_usertagid], false, tag.statecode, TagEntityType.PRESENTATION, tag.indskr_visibility,tag.indskr_filter,tag.indskr_allowusertomodifytag,presentationIdListForBu[tag.indskr_usertagid],presentationIdListForPos[tag.indskr_usertagid]
          )
      });
      presentationTagDetails = uniqBy(presentationTagDetails, 'indskr_usertagid');
      let entriesWithBuOrPosition = presentationTagDetails.filter((resource) =>
          (resource.BUs.includes(this.authService.user.buConfigs.indskr_bulevelconfigurationid) || positionIds.some(position => resource.Posiions.includes(position)) ) && resource.visibility=="600000000"
        );
        
      let entriesWithoutBuAndPosition = presentationTagDetails.filter(
          (resource) => (!resource.BUs.includes(this.authService.user.buConfigs.indskr_bulevelconfigurationid) && !positionIds.every(position => resource.Posiions.includes(position))) && resource.visibility=="600000000"
        );
      
      entriesWithBuOrPosition = presentationTagDetails.filter(tg=>tg.visibility!="600000000").concat(entriesWithBuOrPosition);
      entriesWithBuOrPosition.forEach(async (tagDetails) => {

        const checkTagIndex = this.userTagService.PresentationTags.findIndex(tag => tag.indskr_externalid === tagDetails.indskr_externalid)
        if (checkTagIndex > -1) {
          this.userTagService.PresentationTags.splice(checkTagIndex, 1);
        }
        // if Tag data is updated with presentation
        if (tagDetails.stateCode === TagStateCode.Active) {
          this.userTagService.PresentationTags.push(tagDetails);
          await this.disk.upsertUserTag(tagDetails, TagEntityType.PRESENTATION);
        } else {
          await this.disk.remove(DB_KEY_PREFIXES.USER_TAG + tagDetails.indskr_externalid);
        }
      });
      entriesWithoutBuAndPosition.forEach(async (tagDetails)=>{
        const checkTagIndex = this.userTagService.PresentationTags.findIndex(tag => tag.indskr_externalid === tagDetails.indskr_externalid)

         if (checkTagIndex > -1) {
          this.userTagService.PresentationTags.splice(checkTagIndex, 1);
        }
        await this.disk.remove(DB_KEY_PREFIXES.USER_TAG + tagDetails.indskr_externalid);
      })
      this.userTagService.PresentationTags = this.userTagService.sortUserTags(this.userTagService.PresentationTags);
      this.userTagService.PresentationTags = uniqBy(this.userTagService.PresentationTags,"indskr_externalid")
    }
  }
  ResourceTagMap(updateResourceTags,trackchangeDlt,positionIds){
    updateResourceTags.forEach(record => {
      if (!record['indskr_externalid']) {
        record['indskr_externalid'] = record['indskr_usertagid'];
      }
    });
    let deletedResourceTags = trackchangeDlt;
    if (!isEmpty(deletedResourceTags)) {
      deletedResourceTags.forEach(async trackChangedTag => {
        let index = this.userTagService.resourceTag
        .findIndex(tag => (tag.indskr_usertagid === trackChangedTag['indskr_usertagid']));
        if (index >= 0) {
          await this.disk.remove(DB_KEY_PREFIXES.USER_TAG + this.userTagService.resourceTag[index].indskr_externalid);
          this.userTagService.resourceTag.splice(index, 1);
        }
        });
    }
    if (!isEmpty(updateResourceTags)) {
      let entriesWithBuOrPosition ;
      let entriesWithoutBuAndPosition
      let resourceIdList = this.getresourceIdsForTagIds(updateResourceTags);
      let resourceIdListForBu = this.getBuForUserTags(updateResourceTags);
      let resourceIdListForPos = this.getPosForUserTags(updateResourceTags);

      let resourceTagDetails: UserTag[] = updateResourceTags.map((tag) => {
        return new UserTag(tag.indskr_externalid, tag.indskr_usertagid, tag.deleted, tag.indskr_name, resourceIdList[tag.indskr_usertagid], false, tag.statecode, TagEntityType.RESOURCE, tag.indskr_visibility, tag.indskr_filter,tag.indskr_allowusertomodifytag,resourceIdListForBu[tag.indskr_usertagid],resourceIdListForPos[tag.indskr_usertagid])
      });
      resourceTagDetails = uniqBy(resourceTagDetails, 'indskr_usertagid');
     
      entriesWithBuOrPosition = resourceTagDetails.filter((resource) =>
         ( resource.BUs.includes(this.authService.user.buConfigs.indskr_bulevelconfigurationid) || positionIds.some(position => resource.Posiions.includes(position)) ) && resource.visibility =="600000000"
        );
        
      entriesWithoutBuAndPosition = resourceTagDetails.filter(
          (resource) => !resource.BUs.includes(this.authService.user.buConfigs.indskr_bulevelconfigurationid) && !positionIds.every(position => resource.Posiions.includes(position)) && resource.visibility =="600000000"
        );
      
      entriesWithBuOrPosition = resourceTagDetails.filter(tg=>tg.visibility!="600000000").concat(entriesWithBuOrPosition);
      entriesWithBuOrPosition.forEach(async (tagDetails) => {

        const checkTagIndex = this.userTagService.resourceTag.findIndex(tag => tag.indskr_externalid === tagDetails.indskr_externalid)
        if (checkTagIndex > -1) {
          this.userTagService.resourceTag.splice(checkTagIndex, 1);
        }
        // if Tag data is updated with resource
        if (tagDetails.stateCode === TagStateCode.Active) {
          this.userTagService.resourceTag.push(tagDetails);
          await this.disk.upsertUserTag(tagDetails, TagEntityType.RESOURCE);
        } else {
          await this.disk.remove(DB_KEY_PREFIXES.USER_TAG + tagDetails.indskr_externalid);
        }
      });
      entriesWithoutBuAndPosition.forEach(async (tagDetails)=>{
        const checkTagIndex = this.userTagService.resourceTag.findIndex(tag => tag.indskr_externalid === tagDetails.indskr_externalid)
        if (checkTagIndex > -1) {
          this.userTagService.resourceTag.splice(checkTagIndex, 1);
          await this.disk.remove(DB_KEY_PREFIXES.USER_TAG + tagDetails.indskr_externalid);
        }
      })
      this.userTagService.resourceTag = uniqBy(this.userTagService.resourceTag,"indskr_usertagid");
      this.userTagService.resourceTag = this.userTagService.sortUserTags(this.userTagService.resourceTag);
    }
  }

  private getInitials(name) {
    if (!name) return '';
    const parts = name.trim().split(' ');
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
  }

}
